import { publishAssignments, watchAssignments, assignmentPeriod, overlaps } from '../utils/planningAssignments';
import LiquidText from '../components/LiquidText';
import DeleteIcon from '../components/DeleteIcon';
import { OrcamentoDialog as PlanningDialog, OrcamentoIcon as PlanningIcon, OrcamentoFeedbackProvider as PlanningFeedbackProvider, useOrcamentoFeedback } from '../components/OrcamentoUI';
import { useMaquetesTheme } from '../context/MaquetesThemeContext';
import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import api from '../services/api';
import './Planeamento.css';
import './PlaneamentoTheme.css';
import { gerarTimeline, indicesObrasEmCurso, dataLocal, filtrarObrasPorPesquisa, calcularFocoObra } from '../utils/planeamentoVista';

const PlaneamentoContent = () => {
    const { confirm, notify, prompt } = useOrcamentoFeedback();
    const { theme } = useMaquetesTheme();
    const liquid = theme === 'liquido';
    const [planeamento, setPlaneamento] = useState([]);
    const [loading, setLoading] = useState(true);
    const [statusFilter, setStatusFilter] = useState('ativas'); // 'ativas', 'planeada', 'em_curso', 'concluida', 'todas'
    const [clienteFilter, setClienteFilter] = useState('');
    const [pesquisaObra, setPesquisaObra] = useState('');
    const [obraLocalizada, setObraLocalizada] = useState(null);
    const [dataVista, setDataVista] = useState(null);
    const pesquisaObraRef = useRef(null);
    const [tipoFilter, setTipoFilter] = useState('todas'); // 'todas', 'obra', 'manutencao'
    const [clientes, setClientes] = useState([]);
    const [viewMode, setViewMode] = useState('months');
    const [editingObra, setEditingObra] = useState(null);
    const [availableWorkItems, setAvailableWorkItems] = useState([]);
    const [showWorkManager, setShowWorkManager] = useState(false);
    const headerScrollRef = useRef(null);
    const sidebarScrollRef = useRef(null);
    const mainColumnRef = useRef(null);
    const dragRef = useRef(null); // { obra, startX, currentX, hasMoved }
    const [dragState, setDragState] = useState(null); // Shared state for UI re-renders
    const resizeRef = useRef(null); // { obra, startX, side: 'left' | 'right', deltaDays: 0 }
    const [resizeState, setResizeState] = useState(null);
    const scrollRafRef = useRef(null);

    // Export State
    const [showExportModal, setShowExportModal] = useState(false);
    const [exportType, setExportType] = useState('plano'); // 'plano' ou 'gantt'
    const [exportDates, setExportDates] = useState({ start: '', end: '' });
    const [exportTeamsByLocation, setExportTeamsByLocation] = useState(false);
    // Tipos de intervenção a incluir na exportação de segurança (defeito: só obras)
    const [exportTipos, setExportTipos] = useState(new Set(['obra']));
    // Anexos da obra/pendência (ex.: relatório da fiscalização)
    const [anexos, setAnexos] = useState([]);
    const [anexosNovos, setAnexosNovos] = useState([]); // ficheiros a carregar (obra nova)
    const [anexoBusy, setAnexoBusy] = useState(false);

    // Pending Alerts State
    const [pendingAlerts, setPendingAlerts] = useState([]);
    const [users, setUsers] = useState([]);
    const [justifyModal, setJustifyModal] = useState(null);
    const [justifyText, setJustifyText] = useState('');

    // Atribuição de Trabalhadores
    const [trabalhadoresAptos, setTrabalhadoresAptos] = useState([]);
    const [atribuicoes, setAtribuicoes] = useState([]);
    const [draggedTrabalhador, setDraggedTrabalhador] = useState(null);
    const [dragOverObraId, setDragOverObraId] = useState(null);
    const [ganttHeight, setGanttHeight] = useState(() => {
        const saved = localStorage.getItem('planeamento_gantt_height');
        const n = saved ? parseInt(saved, 10) : NaN;
        return Number.isFinite(n) && n >= 200 ? n : null;
    });
    const [panelHeight, setPanelHeight] = useState(() => {
        const saved = localStorage.getItem('planeamento_panel_height');
        const n = saved ? parseInt(saved, 10) : NaN;
        return Number.isFinite(n) && n >= 80 ? n : null;
    });
    useEffect(() => {
        if (ganttHeight != null) localStorage.setItem('planeamento_gantt_height', String(ganttHeight));
    }, [ganttHeight]);
    useEffect(() => {
        if (panelHeight != null) localStorage.setItem('planeamento_panel_height', String(panelHeight));
    }, [panelHeight]);

    const handleSplitterDown = (e) => {
        e.preventDefault();
        const startY = e.clientY;
        const ganttEl = document.querySelector('.gantt-container');
        const startHeight = ganttEl ? ganttEl.offsetHeight : 400;
        const onMove = (ev) => {
            const delta = ev.clientY - startY;
            const next = Math.max(200, Math.min(window.innerHeight - 180, startHeight + delta));
            setGanttHeight(next);
        };
        const onUp = () => {
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
        };
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
        document.body.style.cursor = 'row-resize';
        document.body.style.userSelect = 'none';
    };

    const handlePanelSplitterDown = (e) => {
        e.preventDefault();
        const startY = e.clientY;
        const panelEl = document.querySelector('.trab-panel');
        const startHeight = panelEl ? panelEl.offsetHeight : 240;
        const onMove = (ev) => {
            const delta = ev.clientY - startY;
            const next = Math.max(80, Math.min(window.innerHeight - 220, startHeight + delta));
            setPanelHeight(next);
        };
        const onUp = () => {
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
        };
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
        document.body.style.cursor = 'row-resize';
        document.body.style.userSelect = 'none';
    };

    const [semanaPanel, setSemanaPanel] = useState(() => {
        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);
        const dow = hoje.getDay();
        const diff = dow === 0 ? -6 : 1 - dow;
        const seg = new Date(hoje);
        seg.setDate(hoje.getDate() + diff);
        return seg;
    });

    // Envios Automáticos
    const [showEnviosAuto, setShowEnviosAuto] = useState(false);
    const [enviosAuto, setEnviosAuto] = useState([]);
    const [clientesOpcoes, setClientesOpcoes] = useState([]);
    const [envioEdit, setEnvioEdit] = useState(null); // null=lista, {}=novo, {id:...}=editar
    const ENVIO_DEFAULTS = {
        nome: '', ativo: true,
        periodicidade: 'semanal', dia_semana: 1, dia_mes: 1, hora_envio: '08:00',
        extensao: '1mes', filtro_cliente: '', tipos_obra: ['obra'],
        dest_responsavel_obra: true, dest_responsavel_interno: false,
        dest_fiscalizacao: false, dest_seguranca: false,
        emails_extra: '',
    };

    // Initial default export dates (current month or week)
    useEffect(() => {
        const today = new Date();
        const startOfWeek = new Date(today);
        startOfWeek.setDate(today.getDate() - today.getDay() + 1); // Monday
        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6); // Sunday

        setExportDates({
            start: startOfWeek.toISOString().split('T')[0],
            end: endOfWeek.toISOString().split('T')[0]
        });
    }, []);

    useEffect(() => {
        fetchPlaneamento();
        fetchWorkItems();
        fetchPendingAlerts();
        fetchUsers();
        fetchTrabalhadoresAptos();
        fetchAtribuicoes();
        fetchClientes();
    }, [statusFilter]);

    const fetchClientes = async () => {
        try {
            const res = await api.get('/clientes');
            setClientes(Array.isArray(res.data) ? res.data : []);
        } catch (err) {
            console.error('Erro ao carregar clientes:', err);
        }
    };

    const hasCenteredRef = useRef(false);

    const fetchUsers = async () => {
        try {
            const res = await api.get('/auth/users');
            setUsers(res.data.users || res.data);
        } catch (err) {
            console.error('Error loading users:', err);
        }
    };

    const fetchPendingAlerts = async () => {
        try {
            const res = await api.get('/planeamento/alertas-pendentes');
            setPendingAlerts(res.data);
        } catch (err) {
            console.error('Error loading pending alerts:', err);
        }
    };

    const fetchWorkItems = async () => {
        try {
            const res = await api.get('/config/trabalhos');
            setAvailableWorkItems(res.data);
        } catch (err) {
            console.error('Error loading work items:', err);
        }
    };

    const fetchTrabalhadoresAptos = async () => {
        try {
            const res = await api.get('/planeamento/trabalhadores-aptos');
            setTrabalhadoresAptos(res.data || []);
        } catch (err) {
            console.error('Erro ao carregar trabalhadores aptos:', err);
        }
    };

    const fetchAtribuicoes = async () => {
        try {
            const res = await api.get('/planeamento/atribuicoes');
            setAtribuicoes(res.data || []);
        } catch (err) {
            console.error('Erro ao carregar atribuições:', err);
        }
    };

    useEffect(() => watchAssignments(() => { fetchAtribuicoes(); fetchTrabalhadoresAptos(); }), []);

    // Iniciais "JoãoT" a partir de "João Tapinina"
    const getIniciais = (nome) => {
        if (!nome) return '';
        const parts = nome.trim().split(/\s+/);
        if (parts.length === 1) return parts[0];
        return parts[0] + parts[parts.length - 1].charAt(0).toUpperCase();
    };

    const formatDate = (d) => {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
    };

    const handleDragStartTrabalhador = (e, trab) => {
        setDraggedTrabalhador(trab);
        e.dataTransfer.effectAllowed = 'copy';
        try { e.dataTransfer.setData('text/plain', String(trab.id)); } catch (_) {}
    };

    const handleDragEndTrabalhador = () => {
        setDraggedTrabalhador(null);
        setDragOverObraId(null);
    };

    const handleDropOnObra = async (e, obra) => {
        e.preventDefault();
        e.stopPropagation();
        setDragOverObraId(null);
        if (!draggedTrabalhador) return;

        // Calcular dia onde foi feito o drop (offsetX dentro da barra)
        const rect = e.currentTarget.getBoundingClientRect();
        const offsetX = e.clientX - rect.left;
        const diaIndex = Math.floor(offsetX / 40);
        const obraInicio = new Date(obra.data_inicio);
        obraInicio.setHours(0, 0, 0, 0);
        const dropDate = new Date(obraInicio);
        dropDate.setDate(obraInicio.getDate() + diaIndex);


        const period = assignmentPeriod(obra, dropDate);
        if (!period) { notify('Esta semana está fora das datas do processo.'); setDraggedTrabalhador(null); return; }
        const conflito = atribuicoes.find(a => String(a.trabalhador_id) === String(draggedTrabalhador.id) && overlaps(a,period.data_inicio,period.data_fim));
        if (conflito) {
            notify(`${draggedTrabalhador.nome} já está atribuído neste período. Escolha outro período ou remova a atribuição existente.`);
            setDraggedTrabalhador(null); return;
        }

        try {
            const res = await api.post('/planeamento/atribuicoes', {
                obra_id: obra.id,
                trabalhador_id: draggedTrabalhador.id,
                ...period
            });
            setAtribuicoes(prev => [...prev, res.data]);
            publishAssignments();
        } catch (err) {
            console.error('Erro ao criar atribuição:', err);
            const serverMsg = err.response?.data?.error || err.response?.data?.detail || err.message;
            notify(serverMsg);
            fetchAtribuicoes();
        }
        setDraggedTrabalhador(null);
    };

    const handleRemoveAtribuicao = async (atribuicaoId) => {
        try {
            await api.delete(`/planeamento/atribuicoes/${atribuicaoId}`);
            setAtribuicoes(prev => prev.filter(a => a.id !== atribuicaoId));
            publishAssignments();
        } catch (err) {
            console.error('Erro ao remover atribuição:', err);
            notify('Erro ao remover atribuição.');
        }
    };

    const fetchPlaneamento = async () => {
        setLoading(true);
        try {
            const statusParam = statusFilter === 'ativas' ? '' : statusFilter;
            const res = await api.get(`/planeamento?status=${statusParam}&_t=${new Date().getTime()}`);
            setPlaneamento(res.data);
            setLoading(false);
        } catch (error) {
            console.error('Erro ao buscar planeamento:', error);
            setLoading(false);
        }
    };

    const handleSaveObra = async (e) => {
        e.preventDefault();

        console.log('=== START SAVING OBRA ===');
        const payload = {
            ...editingObra,
            // tipo_trabalho and detalhes_trabalho should already be updated in the UI
        };

        // ── Criar nova obra ──────────────────────────────────────────────
        if (editingObra.isNew) {
            if (!payload.posicao || !payload.cliente || !payload.data_inicio || !payload.data_fim) {
                notify('Preencha Posição, Cliente, Data Início e Data Fim.');
                return;
            }
            try {
                const res = await api.post('/obras', payload);
                const novaObra = res.data.obra || res.data;
                // Lembrar o cliente para a próxima criação
                if (payload.cliente_id) {
                    try { localStorage.setItem('plan_last_cliente', JSON.stringify({ id: payload.cliente_id, nome: payload.cliente || '' })); } catch {}
                }
                // Carregar os anexos escolhidos antes de a obra existir
                if (anexosNovos.length > 0 && novaObra?.id) {
                    try { await enviarAnexos(novaObra.id, anexosNovos); }
                    catch (err) { notify('Obra criada, mas falhou o envio dos anexos: ' + (err.response?.data?.error || err.message)); }
                    setAnexosNovos([]);
                }
                // Acrescentar ao estado (sem refetch) para não desmontar a Gantt e perder o scroll
                setPlaneamento(prev => [...prev, {
                    ...novaObra,
                    detalhes_trabalho: novaObra.detalhes_trabalho || [],
                    tipo_trabalho: novaObra.tipo_trabalho || [],
                    observacoes: novaObra.observacoes || ''
                }]);
                setEditingObra(null);
                fetchPendingAlerts();
            } catch (error) {
                console.error('Erro ao criar obra:', error);
                notify(`Erro ao criar obra: ${error.response?.data?.message || error.message}`);
            }
            return;
        }

        // ── Atualizar obra existente ─────────────────────────────────────
        // Optimistic Update: Update UI immediately
        setPlaneamento(prev => prev.map(o =>
            o.id === editingObra.id ? { ...o, ...payload } : o
        ));

        try {
            const res = await api.put(`/obras/${editingObra.id}`, payload);
            console.log('Server Response:', res.data);

            const updatedObra = res.data.obra || res.data;
            setPlaneamento(prev => prev.map(o =>
                o.id === editingObra.id ? { ...o, ...updatedObra } : o
            ));

            setEditingObra(null);
            fetchPendingAlerts(); // Refresh alerts after save
            fetchAtribuicoes(); // datas podem ter mudado — o backend ajusta as atribuições, recarregar
        } catch (error) {
            console.error('Erro ao salvar obra:', error);
            notify('Erro ao salvar alterações');
            fetchPlaneamento();
        }
    };

    /* ── Anexos da obra/pendência ─────────────────────────────────── */
    const carregarAnexos = async (obraId) => {
        if (!obraId) { setAnexos([]); return; }
        try {
            const r = await api.get(`/obra-anexos/${obraId}`, { params: { _t: Date.now() } });
            setAnexos(r.data || []);
        } catch { setAnexos([]); }
    };

    const enviarAnexos = async (obraId, ficheiros) => {
        if (!obraId || !ficheiros || ficheiros.length === 0) return;
        const fd = new FormData();
        ficheiros.forEach(f => fd.append('ficheiros', f));
        await api.post(`/obra-anexos/${obraId}`, fd, { timeout: 120000 });
    };

    const handleAnexoUpload = async (e) => {
        const ficheiros = Array.from(e.target.files || []);
        e.target.value = '';
        if (ficheiros.length === 0) return;
        // Obra ainda não existe: guardar para carregar após criar
        if (editingObra?.isNew) { setAnexosNovos(prev => [...prev, ...ficheiros]); return; }
        setAnexoBusy(true);
        try {
            await enviarAnexos(editingObra.id, ficheiros);
            await carregarAnexos(editingObra.id);
        } catch (err) {
            notify('Erro ao carregar anexo: ' + (err.response?.data?.error || err.message));
        } finally { setAnexoBusy(false); }
    };

    const abrirAnexo = async (a) => {
        try {
            const res = await api.get(`/obra-anexos/ficheiro/${a.id}`, { responseType: 'blob' });
            window.open(window.URL.createObjectURL(res.data), '_blank');
        } catch { notify('Erro ao abrir o anexo'); }
    };

    const removerAnexo = async (a) => {
        if (!await confirm(`Remover o anexo "${a.nome_original}"?`)) return;
        try {
            await api.delete(`/obra-anexos/ficheiro/${a.id}`);
            setAnexos(prev => prev.filter(x => x.id !== a.id));
        } catch { notify('Erro ao remover o anexo'); }
    };

    const handleOpenNewModal = () => {
        setAnexos([]); setAnexosNovos([]);
        // Lembrar o último cliente utilizado na criação de obras
        let lastCliente = { id: '', nome: '' };
        try { lastCliente = JSON.parse(localStorage.getItem('plan_last_cliente') || '{}'); } catch {}
        const clienteValido = lastCliente.id && clientes.some(c => String(c.id) === String(lastCliente.id));
        setEditingObra({
            isNew: true,
            posicao: '',
            cliente: clienteValido ? lastCliente.nome : '',
            cliente_id: clienteValido ? String(lastCliente.id) : '',
            descricao: '',
            data_inicio: '',
            data_fim: '',
            status: 'planeada',
            tipo_obra: 'obra',
            cor: '#3182ce',
            detalhes_trabalho: [],
            tipo_trabalho: [],
            observacoes: '',
            responsavel_cliente_id: '',
            responsavel_obra_id: '',
            seguranca_obra_id: '',
            fiscalizacao_id: '',
            gestor_cliente_id: '',
            documentacao_validada: '',
            necessidade_at: '',
            tipo_at: '',
            data_at: '',
            hora_at: ''
        });
    };

    const handleDeleteObra = async () => {
        if (!editingObra) return;

        const confirmed = await confirm(`Tem a certeza que deseja eliminar a obra "${editingObra.posicao}${editingObra.descricao ? ` - ${editingObra.descricao}` : ''}"? Esta ação não pode ser desfeita.`);

        if (!confirmed) return;

        try {
            await api.delete(`/obras/${editingObra.id}`);

            // Update local state
            setPlaneamento(prev => prev.filter(o => o.id !== editingObra.id));
            setEditingObra(null);

            // Optionally refresh alerts
            fetchPendingAlerts();
        } catch (error) {
            console.error('Erro ao eliminar obra:', error);
            notify('Erro ao eliminar obra. Verifique se existem registos dependentes.');
        }
    };

    const handleOpenEditModal = (obra) => {
        console.log('=== ABRIR MODAL EDIÇÃO ===');
        let detalhes = obra.detalhes_trabalho || [];

        if (detalhes.length === 0 && obra.tipo_trabalho && obra.tipo_trabalho.length > 0) {
            // Legacy obra - reconstruct from tipo_trabalho
            detalhes = obra.tipo_trabalho
                .map(nomeTrabalho => {
                    const item = availableWorkItems.find(w => w.nome === nomeTrabalho);
                    return item ? { ...item, quantidade: 1 } : null;
                })
                .filter(item => item !== null);
        }

        // Populate client responsible user data
        const clientResponsavel = users.find(u => u.id === obra.responsavel_cliente_id);
        const internoResponsavel = users.find(u => u.id === obra.responsavel_obra_id);
        const segurancaUser = users.find(u => u.id === obra.seguranca_obra_id);
        const fiscalizacaoUser = users.find(u => u.id === obra.fiscalizacao_id);

        setAnexosNovos([]);
        carregarAnexos(obra.id);
        setEditingObra({
            ...obra,
            detalhes_trabalho: detalhes,
            tipo_trabalho: obra.tipo_trabalho || [],
            email_responsavel_cliente: clientResponsavel ? clientResponsavel.email : '',
            telefone_responsavel_cliente: clientResponsavel ? (clientResponsavel.telefone || '') : '',
            email_responsavel: internoResponsavel ? internoResponsavel.email : '',
            telefone_responsavel: internoResponsavel ? (internoResponsavel.telefone || '') : '',
            email_seguranca: segurancaUser ? segurancaUser.email : '',
            telefone_seguranca: segurancaUser ? (segurancaUser.telefone || '') : '',
            email_fiscalizacao: fiscalizacaoUser ? fiscalizacaoUser.email : '',
            telefone_fiscalizacao: fiscalizacaoUser ? (fiscalizacaoUser.telefone || '') : ''
        });
    };

    const updateObraDates = async (obra, deltaDays, mode = 'move') => {
        const parseSafely = (val) => {
            if (!val) return new Date();
            if (val instanceof Date) return new Date(val.getFullYear(), val.getMonth(), val.getDate());
            try {
                const s = String(val).split('T')[0];
                const parts = s.split('-');
                if (parts.length >= 3) {
                    const [y, m, d] = parts.map(Number);
                    return new Date(y, m - 1, d);
                }
            } catch (e) { }
            const d = new Date(val);
            return isNaN(d.getTime()) ? new Date() : new Date(d.getFullYear(), d.getMonth(), d.getDate());
        };

        const formatSafely = (d) => {
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        };

        try {
            const start = parseSafely(obra.data_inicio);
            const end = parseSafely(obra.data_fim);

            if (mode === 'move') {
                start.setDate(start.getDate() + deltaDays);
                end.setDate(end.getDate() + deltaDays);
            } else if (mode === 'start') {
                start.setDate(start.getDate() + deltaDays);
                if (start > end) start.setTime(end.getTime());
            } else if (mode === 'end') {
                end.setDate(end.getDate() + deltaDays);
                if (end < start) end.setTime(start.getTime());
            }

            const payload = {
                ...obra,
                data_inicio: formatSafely(start),
                data_fim: formatSafely(end)
            };

            // Optimistic Update
            setPlaneamento(prev => prev.map(o =>
                o.id === obra.id ? { ...o, ...payload } : o
            ));

            await api.put(`/obras/${obra.id}`, payload);
            fetchPendingAlerts();
            fetchAtribuicoes(); // o backend ajusta as atribuições às novas datas — recarregar para refletir
            // Não refazer fetchPlaneamento — a update óptimista já atualizou o estado e refetch reseta o scroll
        } catch (error) {
            console.error('Erro ao atualizar datas:', error);
            notify('Erro ao atualizar datas');
            fetchPlaneamento();
        }
    };

    const handleResizeStart = (e, obra, side) => {
        e.stopPropagation(); // Evitar disparar o drag da barra
        if (e.button !== 0) return;

        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';

        const initialResize = {
            obra,
            startX: e.clientX,
            side,
            deltaDays: 0
        };
        resizeRef.current = initialResize;
        setResizeState(initialResize);

        const onMouseMove = (moveEvent) => {
            if (!resizeRef.current) return;
            const deltaX = moveEvent.clientX - resizeRef.current.startX;
            const deltaDays = Math.round(deltaX / 40);

            const updated = { ...resizeRef.current, deltaDays };
            resizeRef.current = updated;
            setResizeState(updated);
        };

        const onMouseUp = () => {
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', onMouseUp);

            const final = resizeRef.current;
            resizeRef.current = null;
            setResizeState(null);

            if (final && final.deltaDays !== 0) {
                updateObraDates(final.obra, final.deltaDays, final.side === 'left' ? 'start' : 'end');
            }
        };

        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
    };

    const handleResizeTouchStart = (e, obra, side) => {
        e.stopPropagation();
        const touch = e.touches[0];

        const initialResize = {
            obra,
            startX: touch.clientX,
            side,
            deltaDays: 0
        };
        resizeRef.current = initialResize;
        setResizeState(initialResize);

        const onTouchMove = (moveEvent) => {
            if (!resizeRef.current) return;
            moveEvent.preventDefault();
            const t = moveEvent.touches[0];
            const deltaX = t.clientX - resizeRef.current.startX;
            const deltaDays = Math.round(deltaX / 40);

            const updated = { ...resizeRef.current, deltaDays };
            resizeRef.current = updated;
            setResizeState(updated);
        };

        const onTouchEnd = () => {
            window.removeEventListener('touchmove', onTouchMove);
            window.removeEventListener('touchend', onTouchEnd);

            const final = resizeRef.current;
            resizeRef.current = null;
            setResizeState(null);

            if (final && final.deltaDays !== 0) {
                updateObraDates(final.obra, final.deltaDays, final.side === 'left' ? 'start' : 'end');
            }
        };

        window.addEventListener('touchmove', onTouchMove, { passive: false });
        window.addEventListener('touchend', onTouchEnd);
    };

    const handleMouseDown = (e, obra) => {
        if (e.button !== 0) return; // Só botão esquerdo

        // Empoderar o cursor globalmente durante o drag
        document.body.style.cursor = 'grabbing';
        document.body.style.userSelect = 'none';

        const initialDrag = {
            obra,
            startX: e.clientX,
            currentX: e.clientX,
            hasMoved: false
        };

        dragRef.current = initialDrag;
        setDragState(initialDrag);

        const onMouseMove = (moveEvent) => {
            if (!dragRef.current) return;

            const deltaX = moveEvent.clientX - dragRef.current.startX;
            const hasMoved = dragRef.current.hasMoved || Math.abs(deltaX) > 5;

            const updated = { ...dragRef.current, currentX: moveEvent.clientX, hasMoved };
            dragRef.current = updated;
            setDragState(updated);
        };

        const onMouseUp = (upEvent) => {
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', onMouseUp);

            const finalDrag = dragRef.current;
            dragRef.current = null;
            setDragState(null);

            if (!finalDrag) return;

            const finalDeltaX = upEvent.clientX - finalDrag.startX;
            const finalHasMoved = finalDrag.hasMoved || Math.abs(finalDeltaX) > 5;

            if (!finalHasMoved) {
                handleOpenEditModal(finalDrag.obra);
            } else {
                const deltaDays = Math.round(finalDeltaX / 40);
                if (deltaDays !== 0) {
                    updateObraDates(finalDrag.obra, deltaDays);
                }
            }
        };

        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
    };

    const handleTouchStart = (e, obra) => {
        const touch = e.touches[0];
        const initialDrag = {
            obra,
            startX: touch.clientX,
            currentX: touch.clientX,
            hasMoved: false
        };
        dragRef.current = initialDrag;
        setDragState(initialDrag);

        const onTouchMove = (moveEvent) => {
            if (!dragRef.current) return;
            const t = moveEvent.touches[0];
            const deltaX = t.clientX - dragRef.current.startX;
            const hasMoved = dragRef.current.hasMoved || Math.abs(deltaX) > 10;

            if (hasMoved) {
                moveEvent.preventDefault();
            }

            const updated = { ...dragRef.current, currentX: t.clientX, hasMoved };
            dragRef.current = updated;
            setDragState(updated);
        };

        const onTouchEnd = (upEvent) => {
            window.removeEventListener('touchmove', onTouchMove);
            window.removeEventListener('touchend', onTouchEnd);

            const finalDrag = dragRef.current;
            dragRef.current = null;
            setDragState(null);

            if (!finalDrag) return;

            if (!finalDrag.hasMoved) {
                handleOpenEditModal(finalDrag.obra);
            } else {
                const finalDeltaX = finalDrag.currentX - finalDrag.startX;
                const deltaDays = Math.round(finalDeltaX / 40);
                if (deltaDays !== 0) {
                    updateObraDates(finalDrag.obra, deltaDays);
                }
            }
        };

        window.addEventListener('touchmove', onTouchMove, { passive: false });
        window.addEventListener('touchend', onTouchEnd);
    };

    const PREDEFINED_COLORS = [
        '#3182ce', '#38a169', '#dd6b20', '#e53e3e',
        '#805ad5', '#d69e2e', '#319795', '#718096'
    ];

    const timeline = useMemo(() => gerarTimeline(planeamento, window.innerWidth, dataVista || new Date()), [planeamento, dataVista]);

    const clientesDisponiveis = useMemo(() => {
        const set = new Set(planeamento.map(o => o.cliente).filter(Boolean));
        return [...set].sort();
    }, [planeamento]);

    const planeamentoFiltrado = useMemo(() => {
        let lista = planeamento;
        if (clienteFilter) lista = lista.filter(o => o.cliente === clienteFilter);
        if (tipoFilter !== 'todas') {
            lista = lista.filter(o => (o.tipo_obra || 'obra') === tipoFilter);
        }
        lista = filtrarObrasPorPesquisa(lista, pesquisaObra);
        // Ordenar cronologicamente pela data de início da intervenção (depois pela data de fim)
        const t = (v) => { const d = v ? new Date(v).getTime() : NaN; return Number.isNaN(d) ? Infinity : d; };
        return [...lista].sort((a, b) => t(a.data_inicio) - t(b.data_inicio) || t(a.data_fim) - t(b.data_fim));
    }, [planeamento, clienteFilter, tipoFilter, pesquisaObra]);

    const localizarObra = (obra) => {
        const inicio = dataLocal(obra.data_inicio);
        if (!inicio) {
            notify('Esta obra não tem uma data de início válida para localizar no calendário.');
            return;
        }
        hasCenteredRef.current = true;
        setDataVista(inicio);
        setObraLocalizada({ id: obra.id });
    };

    // Aguardar a nova janela temporal e as linhas filtradas antes de mover os painéis.
    useEffect(() => {
        if (loading || !obraLocalizada) return;
        const indice = planeamentoFiltrado.findIndex(obra => obra.id === obraLocalizada.id);
        if (indice < 0) return;
        const frame = requestAnimationFrame(() => {
            const grid = mainColumnRef.current;
            const row = grid?.querySelectorAll('.gantt-row-content')[indice];
            if (!grid || !row) return;
            const foco = calcularFocoObra(planeamentoFiltrado[indice], timeline, {
                largura: grid.clientWidth, altura: grid.clientHeight,
                topoLinha: row.offsetTop, alturaLinha: row.offsetHeight,
            });
            if (!foco) return;
            // Cancelar sincronizações anteriores para não reporem a posição antiga.
            if (scrollRafRef.current) cancelAnimationFrame(scrollRafRef.current);
            grid.scrollLeft = foco.left;
            grid.scrollTop = foco.top;
            if (headerScrollRef.current) headerScrollRef.current.scrollLeft = grid.scrollLeft;
            if (sidebarScrollRef.current) sidebarScrollRef.current.scrollTop = grid.scrollTop;
        });
        return () => cancelAnimationFrame(frame);
    }, [loading, obraLocalizada, planeamentoFiltrado, timeline]);

    // Esperar pelo layout completo; os dois painéis e o cabeçalho partilham a mesma posição.
    useEffect(() => {
        if (loading || hasCenteredRef.current || !planeamentoFiltrado.length) return;
        let frame;
        frame = requestAnimationFrame(() => {
            frame = requestAnimationFrame(() => {
                const grid = mainColumnRef.current;
                if (!grid || !grid.clientWidth || !grid.clientHeight) return;
                const hoje = new Date();
                const index = timeline.findIndex(d => d.toDateString() === hoje.toDateString());
                if (index >= 0) {
                    grid.scrollLeft = Math.max(0, index * 40 + 20 - grid.clientWidth / 2);
                    if (headerScrollRef.current) headerScrollRef.current.scrollLeft = grid.scrollLeft;
                }
                const rows = grid.querySelectorAll('.gantt-row-content');
                const centros = indicesObrasEmCurso(planeamentoFiltrado, hoje)
                    .map(i => rows[i]).filter(Boolean)
                    .map(row => row.offsetTop + row.offsetHeight / 2);
                if (centros.length) {
                    const media = centros.reduce((total, y) => total + y, 0) / centros.length;
                    grid.scrollTop = Math.max(0, media - grid.clientHeight / 2);
                    if (sidebarScrollRef.current) sidebarScrollRef.current.scrollTop = grid.scrollTop;
                }
                hasCenteredRef.current = true;
            });
        });
        return () => cancelAnimationFrame(frame);
    }, [loading, planeamentoFiltrado, timeline]);

    // Agrupar timeline por meses para o cabeçalho
    const months = useMemo(() => {
        const result = [];
        let curMonth = -1;
        timeline.forEach(date => {
            const monthYear = date.toLocaleDateString('pt-PT', { month: 'long', year: 'numeric' });
            if (date.getMonth() !== curMonth) {
                curMonth = date.getMonth();
                result.push({ name: monthYear, days: 0 });
            }
            result[result.length - 1].days++;
        });
        return result;
    }, [timeline]);

    const isLastDayOfMonth = (date) => {
        const nextDay = new Date(date);
        nextDay.setDate(date.getDate() + 1);
        return nextDay.getMonth() !== date.getMonth();
    };

    const isWeekend = (date) => date.getDay() === 0 || date.getDay() === 6;

    const isToday = (date) => {
        const today = new Date();
        return date.getDate() === today.getDate() &&
            date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear();
    };

    if (loading) return <div className="p-8">Carregando planeamento...</div>;


    const handleExportClick = (type = 'plano') => {
        setExportType(type);
        setExportTipos(new Set(['obra'])); // abre sempre com "Obras" e os restantes desligados
        setShowExportModal(true);
    };

    const toggleExportTipo = (tipo) => {
        setExportTipos(prev => {
            const next = new Set(prev);
            if (next.has(tipo)) next.delete(tipo); else next.add(tipo);
            return next;
        });
    };

    const handleConfirmAlert = async (alertId, justificacao = '') => {
        try {
            await api.post(`/planeamento/alertas/${alertId}/confirmar`, { justificacao });
            fetchPendingAlerts();
            notify('Alerta enviado com sucesso!');
        } catch (err) {
            console.error('Error confirming alert:', err);
            notify('Erro ao enviar alerta');
        }
    };

    // ── Envios Automáticos ────────────────────────────────────────────────────
    const fetchEnviosAuto = async () => {
        const [eRes, cRes] = await Promise.all([
            api.get('/planeamento/envios-auto'),
            api.get('/planeamento/envios-auto/clientes'),
        ]);
        setEnviosAuto(eRes.data);
        setClientesOpcoes(cRes.data);
    };

    const handleOpenEnviosAuto = async () => {
        await fetchEnviosAuto();
        setShowEnviosAuto(true);
        setEnvioEdit(null);
    };

    const handleSaveEnvio = async () => {
        const payload = { ...envioEdit, tipos_obra: envioEdit.tipos_obra ?? ['obra'] };
        if (!payload.tipos_obra.length) { notify('Selecione pelo menos um tipo de intervenção.'); return; }
        if (!payload.nome.trim()) { notify('Dê um nome ao envio.'); return; }
        try {
            if (payload.id) {
                await api.put(`/planeamento/envios-auto/${payload.id}`, payload);
            } else {
                await api.post('/planeamento/envios-auto', payload);
            }
            await fetchEnviosAuto();
            setEnvioEdit(null);
        } catch (e) {
            notify(e.response?.data?.error || 'Erro ao guardar');
        }
    };

    const handleDeleteEnvio = async (id) => {
        if (!await confirm('Apagar este envio automático?')) return;
        await api.delete(`/planeamento/envios-auto/${id}`);
        setEnviosAuto(prev => prev.filter(e => e.id !== id));
    };

    const handleEnviarAgora = async (id) => {
        try {
            const r = await api.post(`/planeamento/envios-auto/${id}/enviar-agora`);
            notify(`Email enviado para ${r.data.enviados} destinatário(s).`);
        } catch (e) {
            notify(e.response?.data?.error || 'Erro ao enviar');
        }
    };

    const handleEnviarTeste = async (id) => {
        const email = await prompt('Email de teste (recebe a pré-visualização do planeamento):');
        if (!email) return;
        if (!/.+@.+\..+/.test(email.trim())) {
            notify('Email inválido');
            return;
        }
        try {
            await api.post(`/planeamento/envios-auto/${id}/enviar-teste`, { email: email.trim() });
            notify(`Email de teste enviado para ${email.trim()}.`);
        } catch (e) {
            notify(e.response?.data?.error || 'Erro ao enviar teste');
        }
    };

    const handleEnviarEmails = async (id) => {
        const raw = await prompt('Emails de destino (separados por vírgula):\n\nEx.: joao@empresa.pt, maria@empresa.pt, fiscal@cliente.com');
        if (!raw) return;
        try {
            const r = await api.post(`/planeamento/envios-auto/${id}/enviar-emails`, { emails: raw });
            const dest = r.data.destinatarios || [];
            const inv = r.data.invalidos || [];
            let msg = `Email enviado para ${r.data.enviados} destinatário(s):\n${dest.join(', ')}`;
            if (inv.length > 0) msg += `\n\n⚠️ Emails inválidos ignorados: ${inv.join(', ')}`;
            notify(msg);
        } catch (e) {
            notify(e.response?.data?.error || 'Erro ao enviar');
        }
    };

    const handleConfirmWithJustify = async () => {
        if (!justifyModal) return;
        await handleConfirmAlert(justifyModal.id, justifyText);
        setJustifyModal(null);
        setJustifyText('');
    };

    const handleDismissAlert = async (alertId) => {
        try {
            await api.post(`/planeamento/alertas/${alertId}/dispensar`);
            fetchPendingAlerts();
        } catch (err) {
            console.error('Error dismissing alert:', err);
        }
    };

    const handleDismissAllAlerts = async () => {
        if (pendingAlerts.length === 0) return;
        if (!await confirm(`Dispensar todos os ${pendingAlerts.length} avisos?`)) return;
        try {
            await Promise.all(pendingAlerts.map(a => api.post(`/planeamento/alertas/${a.id}/dispensar`)));
            fetchPendingAlerts();
        } catch (err) {
            console.error('Error dismissing all alerts:', err);
            notify('Erro ao dispensar todos os avisos.');
            fetchPendingAlerts();
        }
    };

    const handleSendAllAlerts = async () => {
        if (pendingAlerts.length === 0) return;
        if (!await confirm(`Enviar todos os ${pendingAlerts.length} avisos?`)) return;
        try {
            for (const a of pendingAlerts) {
                await handleConfirmAlert(a.id);
            }
        } catch (err) {
            console.error('Error sending all alerts:', err);
            notify('Erro ao enviar todos os avisos.');
            fetchPendingAlerts();
        }
    };

    const confirmExport = async () => {
        try {
            const { start, end } = exportDates;
            if (!start || !end) {
                notify('Selecione as datas de início e fim.');
                return;
            }

            const endpoint = exportType === 'gantt' ? 'export-gantt' : 'export';
            const filename = exportType === 'gantt' ? `planeamento_visual_${start}_${end}.xlsx` : `planeamento_seguranca_${start}_${end}.xlsx`;

            if (exportType !== 'gantt' && exportTipos.size === 0) {
                notify('Selecione pelo menos um tipo de intervenção.');
                return;
            }
            const teamsParam = (exportType === 'gantt' && exportTeamsByLocation) ? '&equipas=1' : '';
            const tiposParam = exportType !== 'gantt' ? `&tipos=${Array.from(exportTipos).join(',')}` : '';
            const response = await api.get(`/planeamento/${endpoint}?start=${start}&end=${end}${teamsParam}${tiposParam}`, {
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            setShowExportModal(false);
        } catch (error) {
            console.error('Erro ao exportar:', error);
            notify('Erro ao exportar Excel');
        }
    };



    return (
        <div className="planeamento-container">
            {/* Export Modal */}
            {showExportModal && (
                <PlanningDialog data-planning-dialog="true" label="Planeamento" onClose={() => setShowExportModal(false)}>
                    <div className={liquid ? "planeamento-modal-content modal-ef" : "planeamento-modal-content"} style={{ maxWidth: '400px' }}>
                        <header className={liquid ? "modal-header modal-ef-header" : "modal-header"}>
                            <h2><PlanningIcon name={exportType === 'gantt' ? 'download' : 'document'} fallback={exportType === 'gantt' ? '📊' : '📋'} /> {exportType === 'gantt' ? 'Exportar Planeamento (Visual)' : 'Exportar Planeamento Segurança'}</h2>
                            <button className={liquid ? "btn-close modal-close" : "btn-close"} aria-label="Fechar" onClick={() => setShowExportModal(false)}><PlanningIcon name="close" fallback="×" /></button>
                        </header>
                        <div className={liquid ? "modal-form-body planeamento-dialog-body" : undefined} style={{ padding: '20px' }}>
                            <div className="form-group">
                                <label>Data Início:</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={exportDates.start}
                                    onChange={e => setExportDates({ ...exportDates, start: e.target.value })}
                                />
                            </div>
                            <div className="form-group" style={{ marginTop: '15px' }}>
                                <label>Data Fim:</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={exportDates.end}
                                    onChange={e => setExportDates({ ...exportDates, end: e.target.value })}
                                />
                            </div>
                            {exportType === 'gantt' && (
                                <div className="form-group" style={{ marginTop: '18px' }}>
                                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontWeight: 'normal' }}>
                                        <input
                                            type="checkbox"
                                            checked={exportTeamsByLocation}
                                            onChange={e => setExportTeamsByLocation(e.target.checked)}
                                            style={{ width: 'auto', margin: 0 }}
                                        />
                                        <span>Incluir equipas por local</span>
                                    </label>
                                </div>
                            )}
                            {exportType !== 'gantt' && (
                                <div className="form-group" style={{ marginTop: '18px' }}>
                                    <label style={{ fontWeight: 600, marginBottom: 6, display: 'block' }}>Tipos de intervenção a incluir:</label>
                                    {[
                                        ['obra', 'Obras'],
                                        ['manutencao', 'Obras Manutenção'],
                                        ['pendencia', 'Pendências'],
                                    ].map(([k, l]) => (
                                        <label key={k} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontWeight: 'normal', padding: '4px 0' }}>
                                            <input
                                                type="checkbox"
                                                checked={exportTipos.has(k)}
                                                onChange={() => toggleExportTipo(k)}
                                                style={{ width: 'auto', margin: 0 }}
                                            />
                                            <span>{l}</span>
                                        </label>
                                    ))}
                                </div>
                            )}
                            <div data-liquid-actions="true" style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                                <button className="btn-secondary" onClick={() => setShowExportModal(false)}>Cancelar</button>
                                <button className="btn-primary" onClick={confirmExport}>Confirmar Exportação</button>
                            </div>
                        </div>
                    </div>
                </PlanningDialog>
            )}
            {/* Modal Envios Automáticos */}
            {showEnviosAuto && (
                <PlanningDialog data-planning-dialog="true" label="Planeamento" onClose={() => { setShowEnviosAuto(false); setEnvioEdit(null); }}>
                    <div className={liquid ? "planeamento-modal-content modal-ef" : "planeamento-modal-content"} style={{ maxWidth: 720, width: '95vw' }}>
                        <header className={liquid ? "modal-header modal-ef-header" : "modal-header"}>
                            <h2><PlanningIcon name="bell" fallback="🔔" /> Alertas Automáticos de Planeamento</h2>
                            <button className={liquid ? "btn-close modal-close" : "btn-close"} aria-label="Fechar" onClick={() => { setShowEnviosAuto(false); setEnvioEdit(null); }}><PlanningIcon name="close" fallback="×" /></button>
                        </header>
                        <div className={liquid ? "modal-form-body planeamento-dialog-body" : undefined} style={{ padding: '0 20px 20px' }}>
                            {/* ── LISTA ── */}
                            {!envioEdit && (
                                <>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '16px 0 10px' }}>
                                        <button className="btn-primary" style={{ padding: '7px 16px', fontSize: 13 }}
                                            onClick={() => setEnvioEdit({ ...ENVIO_DEFAULTS })}>
                                            + Novo envio
                                        </button>
                                    </div>
                                    {enviosAuto.length === 0 ? (
                                        <p style={{ textAlign: 'center', color: '#888', padding: '30px 0' }}>Nenhum envio configurado.</p>
                                    ) : (
                                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                                            <thead>
                                                <tr style={{ background: '#f1f5f9', color: '#374151' }}>
                                                    <th style={{ padding: '8px 10px', textAlign: 'left' }}>Nome</th>
                                                    <th style={{ padding: '8px 10px', textAlign: 'left' }}>Periodicidade</th>
                                                    <th style={{ padding: '8px 10px', textAlign: 'left' }}>Extensão</th>
                                                    <th style={{ padding: '8px 10px', textAlign: 'left' }}>Cliente</th>
                                                    <th style={{ padding: '8px 10px', textAlign: 'center' }}>Ativo</th>
                                                    <th style={{ padding: '8px 10px', textAlign: 'left' }}>Último envio</th>
                                                    <th style={{ padding: '8px 10px' }}></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {enviosAuto.map(e => {
                                                    const diasSemana = ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'];
                                                    const periLabel = {
                                                        diaria: 'Diária',
                                                        semanal: `Semanal (${diasSemana[e.dia_semana] || ''})`,
                                                        quinzenal: `Quinzenal (${diasSemana[e.dia_semana] || ''})`,
                                                        mensal: `Mensal (dia ${e.dia_mes})`,
                                                    }[e.periodicidade] || e.periodicidade;
                                                    const extLabel = { '1semana': '1 Semana', '2semanas': '2 Semanas', '1mes': '1 Mês', '2meses': '2 Meses', '3meses': '3 Meses' }[e.extensao] || e.extensao;
                                                    return (
                                                        <tr key={e.id} style={{ borderBottom: '1px solid #e5e7eb' }}>
                                                            <td style={{ padding: '8px 10px', fontWeight: 600 }}>{e.nome}<small style={{ display: 'block', fontWeight: 400, color: '#52677e', marginTop: 4 }}>{(e.tipos_obra ?? ['obra']).map(t => ({ obra: 'Obras', manutencao: 'Manutenção', pendencia: 'Pendências' }[t])).join(' · ')}</small></td>
                                                            <td style={{ padding: '8px 10px' }}>{periLabel} {e.hora_envio}</td>
                                                            <td style={{ padding: '8px 10px' }}>{extLabel}</td>
                                                            <td style={{ padding: '8px 10px', color: e.filtro_cliente ? '#1d4ed8' : '#9ca3af', fontSize: 12 }}>
                                                                {e.filtro_cliente
                                                                    ? e.filtro_cliente.split('|').map(c => c.trim()).filter(Boolean).join(' · ')
                                                                    : 'Todos'}
                                                            </td>
                                                            <td style={{ padding: '8px 10px', textAlign: 'center' }}>
                                                                <span style={{ color: e.ativo ? '#16a34a' : '#9ca3af', fontWeight: 700 }}><LiquidText>{e.ativo ? '✓' : '–'}</LiquidText></span>
                                                            </td>
                                                            <td style={{ padding: '8px 10px', color: '#6b7280', fontSize: 12 }}>
                                                                {e.ultimo_envio ? new Date(e.ultimo_envio).toLocaleString('pt-PT') : '—'}
                                                            </td>
                                                            <td style={{ padding: '8px 6px', whiteSpace: 'nowrap' }}>
                                                                <button title="Enviar agora (para todos)" style={{ background: '#dbeafe', border: 'none', borderRadius: 4, padding: '3px 8px', cursor: 'pointer', marginRight: 4, fontSize: 12 }} onClick={() => handleEnviarAgora(e.id)}><PlanningIcon name="send" fallback="▶" /></button>
                                                                <button title="Enviar teste (só para 1 email)" style={{ background: '#fef3c7', border: 'none', borderRadius: 4, padding: '3px 8px', cursor: 'pointer', marginRight: 4, fontSize: 12 }} onClick={() => handleEnviarTeste(e.id)}><PlanningIcon name="test" fallback="🧪" /></button>
                                                                <button title="Enviar agora para emails específicos (separados por vírgula)" style={{ background: '#dcfce7', border: 'none', borderRadius: 4, padding: '3px 8px', cursor: 'pointer', marginRight: 4, fontSize: 12 }} onClick={() => handleEnviarEmails(e.id)}><PlanningIcon name="mail" fallback="📧" /></button>
                                                                <button title="Editar" style={{ background: '#f3f4f6', border: 'none', borderRadius: 4, padding: '3px 8px', cursor: 'pointer', marginRight: 4, fontSize: 12 }} onClick={() => setEnvioEdit({ ...e, tipos_obra: e.tipos_obra ?? ['obra'], filtro_cliente: e.filtro_cliente || '', emails_extra: e.emails_extra || '' })}><PlanningIcon name="edit" fallback="✏️" /></button>
                                                                <button title="Apagar" style={{ background: '#fee2e2', border: 'none', borderRadius: 4, padding: '3px 8px', cursor: 'pointer', fontSize: 12 }} onClick={() => handleDeleteEnvio(e.id)}><PlanningIcon name="trash" fallback="✕" /></button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    )}
                                </>
                            )}

                            {/* ── FORMULÁRIO CRIAR / EDITAR ── */}
                            {envioEdit && (() => {
                                const set = (k, v) => setEnvioEdit(prev => ({ ...prev, [k]: v }));
                                const diasSemana = [{ v: 0, l: 'Domingo' }, { v: 1, l: 'Segunda' }, { v: 2, l: 'Terça' }, { v: 3, l: 'Quarta' }, { v: 4, l: 'Quinta' }, { v: 5, l: 'Sexta' }, { v: 6, l: 'Sábado' }];
                                const f = { fontSize: 13 };
                                const lbl = { fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 4 };
                                const inp = { fontSize: 13, padding: '6px 8px', borderRadius: 4, border: '1px solid #d1d5db', width: '100%', boxSizing: 'border-box' };
                                return (
                                    <div style={{ marginTop: 16 }}>
                                        <h3 style={{ fontSize: 14, marginBottom: 16, color: '#1e3a5f' }}>{envioEdit.id ? 'Editar envio' : 'Novo envio automático'}</h3>
                                        <div className="planeamento-envio-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>

                                            {/* Nome */}
                                            <div style={{ gridColumn: '1/-1' }}>
                                                <label style={lbl}>Nome</label>
                                                <input style={inp} value={envioEdit.nome} onChange={e => set('nome', e.target.value)} placeholder="Ex: Planeamento GALP semanal" />
                                            </div>

                                            {/* Periodicidade */}
                                            <div>
                                                <label style={lbl}>Periodicidade</label>
                                                <select style={inp} value={envioEdit.periodicidade} onChange={e => set('periodicidade', e.target.value)}>
                                                    <option value="diaria">Diária</option>
                                                    <option value="semanal">Semanal</option>
                                                    <option value="quinzenal">Quinzenal</option>
                                                    <option value="mensal">Mensal</option>
                                                </select>
                                            </div>

                                            {/* Hora */}
                                            <div>
                                                <label style={lbl}>Hora de envio</label>
                                                <input type="time" style={inp} value={envioEdit.hora_envio} onChange={e => set('hora_envio', e.target.value)} />
                                            </div>

                                            {/* Dia da semana (semanal/quinzenal) */}
                                            {(envioEdit.periodicidade === 'semanal' || envioEdit.periodicidade === 'quinzenal') && (
                                                <div>
                                                    <label style={lbl}>Dia da semana</label>
                                                    <select style={inp} value={envioEdit.dia_semana} onChange={e => set('dia_semana', parseInt(e.target.value))}>
                                                        {diasSemana.map(d => <option key={d.v} value={d.v}>{d.l}</option>)}
                                                    </select>
                                                </div>
                                            )}

                                            {/* Dia do mês (mensal) */}
                                            {envioEdit.periodicidade === 'mensal' && (
                                                <div>
                                                    <label style={lbl}>Dia do mês</label>
                                                    <input type="number" min={1} max={28} style={inp} value={envioEdit.dia_mes} onChange={e => set('dia_mes', parseInt(e.target.value))} />
                                                </div>
                                            )}

                                            {/* Extensão */}
                                            <div>
                                                <label style={lbl}>Extensão do planeamento</label>
                                                <select style={inp} value={envioEdit.extensao} onChange={e => set('extensao', e.target.value)}>
                                                    <option value="1semana">Próxima semana</option>
                                                    <option value="2semanas">Próximas 2 semanas</option>
                                                    <option value="1mes">Próximo mês</option>
                                                    <option value="2meses">Próximos 2 meses</option>
                                                    <option value="3meses">Próximos 3 meses</option>
                                                </select>
                                            </div>

                                            <fieldset className="envio-tipos" style={{ gridColumn: '1/-1' }}>
                                                <legend>Intervenções a incluir</legend>
                                                <div>
                                                    {[['obra', 'Obras'], ['manutencao', 'Manutenção'], ['pendencia', 'Pendências']].map(([tipo, label]) => (
                                                        <label key={tipo}>
                                                            <input type="checkbox" checked={(envioEdit.tipos_obra ?? ['obra']).includes(tipo)}
                                                                onChange={e => set('tipos_obra', e.target.checked
                                                                    ? [...(envioEdit.tipos_obra ?? ['obra']), tipo]
                                                                    : (envioEdit.tipos_obra ?? ['obra']).filter(t => t !== tipo))} />
                                                            <LiquidText>{label}</LiquidText>
                                                        </label>
                                                    ))}
                                                </div>
                                                <small>O email e o PDF incluem apenas os tipos selecionados.</small>
                                            </fieldset>

                                            {/* Filtro cliente — multi-seleção por checkboxes */}
                                            <div style={{ gridColumn: '1/-1' }}>
                                                <label style={lbl}>Filtrar por cliente <span style={{ fontWeight: 400, color: '#9ca3af' }}>(deixe vazio para todos)</span></label>
                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 16px', marginTop: 6, maxHeight: 140, overflowY: 'auto', overflowX: 'hidden', padding: '8px', border: '1px solid #e5e7eb', borderRadius: 4, background: '#fafafa', boxSizing: 'border-box', width: '100%' }}>
                                                    {clientesOpcoes.map(c => {
                                                        const selecionados = envioEdit.filtro_cliente ? envioEdit.filtro_cliente.split('|').map(x => x.trim()).filter(Boolean) : [];
                                                        const checked = selecionados.includes(c);
                                                        const toggle = () => {
                                                            const novo = checked
                                                                ? selecionados.filter(x => x !== c)
                                                                : [...selecionados, c];
                                                            set('filtro_cliente', novo.join('|'));
                                                        };
                                                        return (
                                                            <label key={c} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                                                <input type="checkbox" checked={checked} onChange={toggle} />
                                                                {c}
                                                            </label>
                                                        );
                                                    })}
                                                </div>
                                            </div>

                                            {/* Destinatários */}
                                            <div style={{ gridColumn: '1/-1' }}>
                                                <label style={lbl}>Destinatários (intervenientes de obra)</label>
                                                <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap', marginTop: 4 }}>
                                                    {[
                                                        { k: 'dest_responsavel_obra', l: 'Resp. Obra (cliente)' },
                                                        { k: 'dest_responsavel_interno', l: 'Resp. Interno' },
                                                        { k: 'dest_fiscalizacao', l: 'Fiscalização' },
                                                        { k: 'dest_seguranca', l: 'Segurança' },
                                                    ].map(({ k, l }) => (
                                                        <label key={k} style={{ ...f, display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
                                                            <input type="checkbox" checked={!!envioEdit[k]} onChange={e => set(k, e.target.checked)} />
                                                            {l}
                                                        </label>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Emails extra */}
                                            <div style={{ gridColumn: '1/-1' }}>
                                                <label style={lbl}>Emails adicionais (separados por vírgula)</label>
                                                <input style={inp} value={envioEdit.emails_extra} onChange={e => set('emails_extra', e.target.value)} placeholder="email1@empresa.com, email2@empresa.com" />
                                            </div>

                                            {/* Ativo */}
                                            <div style={{ gridColumn: '1/-1' }}>
                                                <label style={{ ...f, display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                                                    <input type="checkbox" checked={!!envioEdit.ativo} onChange={e => set('ativo', e.target.checked)} />
                                                    <strong>Ativo</strong> (envios automáticos em funcionamento)
                                                </label>
                                            </div>
                                        </div>

                                        <div data-liquid-actions="true" style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 20 }}>
                                            <button className="btn-secondary" style={{ padding: '7px 16px', fontSize: 13 }} onClick={() => setEnvioEdit(null)}>Cancelar</button>
                                            <button className="btn-primary" style={{ padding: '7px 18px', fontSize: 13 }} onClick={handleSaveEnvio}>Guardar</button>
                                        </div>
                                    </div>
                                );
                            })()}
                        </div>
                    </div>
                </PlanningDialog>
            )}

            {/* Top Bar Uniforme */}
            <div className="top-bar">
                <div className="top-bar-left">
                    <div className="top-bar-title">
                        <h1><PlanningIcon name="calendar" fallback="📅" /> Planeamento</h1>
                        <p>Gestão de calendário e obras</p>
                    </div>
                </div>
                <div className="top-bar-actions">
                    <div className="planeamento-toolbar-controls" style={{ display: 'flex', gap: '8px', marginLeft: '10px', alignItems: 'center' }}>
                        <button className="btn-primary" onClick={handleOpenNewModal} style={{ padding: '8px 15px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                            + Nova Obra
                        </button>
                        <select
                            value={clienteFilter}
                            onChange={e => setClienteFilter(e.target.value)}
                            style={{ padding: '7px 10px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 13, color: clienteFilter ? '#1d4ed8' : '#374151', fontWeight: clienteFilter ? 600 : 400, cursor: 'pointer' }}
                        >
                            <option value="">Todos os clientes</option>
                            {clientesDisponiveis.map(c => <option key={c} value={c}>{c}</option>)}
                        </select>
                        <button className="btn-secondary" onClick={handleOpenEnviosAuto} style={{ padding: '8px 15px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <PlanningIcon name="bell" fallback="🔔" /> Alertas Auto
                        </button>
                        <button className="btn-secondary" onClick={() => handleExportClick('plano')} style={{ padding: '8px 15px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <PlanningIcon name="document" fallback="📋" /> Planeamento Segurança
                        </button>
                        <button className="btn-primary" onClick={() => handleExportClick('gantt')} style={{ padding: '8px 15px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <PlanningIcon name="download" fallback="📊" /> Exportar Planeamento
                        </button>
                    </div>
                </div>
                <div className="planeamento-header-filters">
                    <form className="planeamento-search" role="search" aria-label="Pesquisar no planeamento"
                        onSubmit={e => { e.preventDefault(); if (!loading && planeamentoFiltrado.length) localizarObra(planeamentoFiltrado[0]); }}>
                        <label htmlFor="planeamento-pesquisa">Pesquisar obra</label>
                        <div className="planeamento-search-controls shared-search">
                            <input id="planeamento-pesquisa" ref={pesquisaObraRef} type="search"
                                placeholder="Nome ou posição da obra…" value={pesquisaObra}
                                aria-describedby="planeamento-pesquisa-estado"
                                onChange={e => { setPesquisaObra(e.target.value); setObraLocalizada(null); }} />
                            {pesquisaObra && <button type="button" className="btn-secondary" onClick={() => {
                                setPesquisaObra(''); pesquisaObraRef.current?.focus();
                            }}>Limpar</button>}
                            <button type="submit" className="btn-secondary" disabled={loading || !planeamentoFiltrado.length}>
                                {planeamentoFiltrado.length > 1 ? 'Ir à primeira' : 'Ir à obra'}
                            </button>
                        </div>
                        <span id="planeamento-pesquisa-estado" className="planeamento-search-status" role="status">
                            {loading ? 'A carregar obras…' : planeamentoFiltrado.length === 0
                                ? 'Nenhuma obra encontrada. Altere a pesquisa ou os filtros.'
                                : `${planeamentoFiltrado.length} ${planeamentoFiltrado.length === 1 ? 'obra' : 'obras'} · Clique no nome para localizar no calendário.`}
                        </span>
                    </form>
                    <div className="shared-subnav" style={{ marginBottom: 0 }}>
                        <button className={`shared-subnav-btn ${statusFilter === 'ativas' ? 'active' : ''}`} onClick={() => setStatusFilter('ativas')}>Ativas</button>
                        <button className={`shared-subnav-btn ${statusFilter === 'planeada' ? 'active' : ''}`} onClick={() => setStatusFilter('planeada')}>Planeadas</button>
                        <button className={`shared-subnav-btn ${statusFilter === 'em_curso' ? 'active' : ''}`} onClick={() => setStatusFilter('em_curso')}>Em Curso</button>
                        <button className={`shared-subnav-btn ${statusFilter === 'concluida' ? 'active' : ''}`} onClick={() => setStatusFilter('concluida')}>Concluídas</button>
                        <button className={`shared-subnav-btn ${statusFilter === 'todas' ? 'active' : ''}`} onClick={() => setStatusFilter('todas')}>Todas</button>
                    </div>
                    <div className="shared-subnav" style={{ marginBottom: 0, marginLeft: '10px' }}>
                        <button className={`shared-subnav-btn ${tipoFilter === 'todas' ? 'active' : ''}`} onClick={() => setTipoFilter('todas')}>Todas</button>
                        <button className={`shared-subnav-btn ${tipoFilter === 'obra' ? 'active' : ''}`} onClick={() => setTipoFilter('obra')}>Obras</button>
                        <button className={`shared-subnav-btn ${tipoFilter === 'manutencao' ? 'active' : ''}`} onClick={() => setTipoFilter('manutencao')}>Manutenção</button>
                        <button className={`shared-subnav-btn ${tipoFilter === 'pendencia' ? 'active' : ''}`} onClick={() => setTipoFilter('pendencia')}>Pendências</button>
                    </div>
                </div>
            </div>

            {/* Conteúdo da Página */}
            <div className="page-content">


                {planeamento.length === 0 && !loading ? (
                    <div className="empty-state" style={{ padding: '50px', textAlign: 'center', background: 'white', borderRadius: '12px' }}>
                        <h3>Nenhuma obra encontrada</h3>
                        <p>Altere os filtros ou crie novas obras com datas definidas.</p>
                    </div>
                ) : (
                    <div className="gantt-wrapper">
                        <div className="gantt-container" style={ganttHeight != null ? { height: `${ganttHeight}px` } : undefined}>
                            {/* Headers Row - Fixed Top */}
                            <div className="gantt-headers-row" style={{ display: 'flex', borderBottom: '2px solid #edf2f7' }}>
                                <div className="gantt-sidebar-header">Projetos / Equipas</div>

                                <div className="gantt-timeline-header-wrapper" style={{ overflow: 'hidden', flex: 1, display: 'flex', flexDirection: 'column' }} ref={headerScrollRef}>
                                    <div className="gantt-timeline-header">
                                        {months.map((m, i) => (
                                            <div
                                                key={i}
                                                className="gantt-timeline-month"
                                                style={{
                                                    width: `${m.days * 40}px`,
                                                    minWidth: `${m.days * 40}px`
                                                }}
                                            >
                                                {m.name}
                                            </div>
                                        ))}
                                    </div>
                                    <div className="gantt-timeline-days">
                                        {timeline.map((date, i) => {
                                            const weekDays = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'];
                                            const dayLabel = weekDays[date.getDay()];
                                            const semFim = new Date(semanaPanel); semFim.setDate(semanaPanel.getDate() + 6);
                                            const inSelectedWeek = date >= semanaPanel && date <= semFim;
                                            return (
                                                <div
                                                    key={i}
                                                    className={`gantt-day-cell ${isWeekend(date) ? 'weekend' : ''} ${isLastDayOfMonth(date) ? 'month-end' : ''} ${isToday(date) ? 'today' : ''} ${date.getDay() === 1 ? 'week-start' : ''} ${inSelectedWeek ? 'selected-week' : ''}`}
                                                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', lineHeight: '1.2' }}
                                                >
                                                    <span style={{ fontSize: '13px', fontWeight: 'bold' }}>{date.getDate()}</span>
                                                    <span style={{ fontSize: '9px', fontWeight: 'normal', color: '#718096', textTransform: 'uppercase' }}>{dayLabel}</span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>

                            {/* Scrollable Body - Syncs Vertical Scroll */}
                            <div className="gantt-body-scroll" style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
                                {/* Sidebar Column */}
                                <div className="gantt-sidebar-column" ref={sidebarScrollRef}
                                    onScroll={(e) => {
                                        const scrollTop = e.target.scrollTop;
                                        if (scrollRafRef.current) cancelAnimationFrame(scrollRafRef.current);
                                        scrollRafRef.current = requestAnimationFrame(() => {
                                            if (mainColumnRef.current && mainColumnRef.current.scrollTop !== scrollTop) {
                                                mainColumnRef.current.scrollTop = scrollTop;
                                            }
                                            if (headerScrollRef.current && mainColumnRef.current) {
                                                headerScrollRef.current.scrollLeft = mainColumnRef.current.scrollLeft;
                                            }
                                        });
                                    }}
                                >
                                    {planeamentoFiltrado.map(obra => (
                                        <button type="button" key={obra.id}
                                            className={`gantt-row-label gantt-obra-location ${obraLocalizada?.id === obra.id ? 'obra-localizada' : ''}`}
                                            onClick={() => localizarObra(obra)}
                                            title={`Localizar ${obra.posicao}${obra.descricao ? ` - ${obra.descricao}` : ''} no calendário`}>
                                            <div className="obra-dot" style={{ backgroundColor: obra.cor || '#4a90e2', '--obra-cor': obra.cor || '#4a90e2' }}></div>
                                            <div className="obra-info">
                                                <strong title={`${obra.posicao}${obra.descricao ? ` - ${obra.descricao}` : ''}`}>{obra.posicao}{obra.descricao ? ` - ${obra.descricao}` : ''}</strong>
                                                <small>{obra.cliente}</small>
                                            </div>
                                        </button>
                                    ))}
                                </div>

                                {/* Main Grid Column */}
                                <div
                                    className="gantt-main-column"
                                    ref={mainColumnRef}
                                    style={{ flex: 1, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}
                                    onScroll={(e) => {
                                        const { scrollLeft, scrollTop } = e.target;
                                        if (scrollRafRef.current) cancelAnimationFrame(scrollRafRef.current);
                                        scrollRafRef.current = requestAnimationFrame(() => {
                                            if (headerScrollRef.current) {
                                                headerScrollRef.current.scrollLeft = scrollLeft;
                                            }
                                            if (sidebarScrollRef.current && sidebarScrollRef.current.scrollTop !== scrollTop) {
                                                sidebarScrollRef.current.scrollTop = scrollTop;
                                            }
                                        });
                                    }}
                                >
                                    <div className="gantt-content-wrapper" style={{ width: 'fit-content', position: 'relative' }}>
                                        {/* Linhas verticais de início de semana (Segunda-feira) */}
                                        {timeline.map((date, i) => date.getDay() === 1 ? (
                                            <div key={`wk-${i}`} className="gantt-week-line" style={{ left: `${i * 40}px` }} />
                                        ) : null)}
                                        {/* Destaque da semana seleccionada no painel */}
                                        {(() => {
                                            if (timeline.length === 0) return null;
                                            const tlStart = new Date(timeline[0]);
                                            tlStart.setHours(0, 0, 0, 0);
                                            const sel = new Date(semanaPanel);
                                            sel.setHours(0, 0, 0, 0);
                                            const offsetDias = Math.round((sel - tlStart) / 86400000);
                                            if (offsetDias + 7 < 0 || offsetDias >= timeline.length) return null;
                                            const left = Math.max(0, offsetDias) * 40;
                                            const right = Math.min(timeline.length, offsetDias + 7) * 40;
                                            return <div className="gantt-selected-week" style={{ left: `${left}px`, width: `${right - left}px` }} />;
                                        })()}
                                        {/* Marcador de Hoje */}
                                        {(() => {
                                            const today = new Date();
                                            const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
                                            const offset = calculateOffset(todayStr, timeline);
                                            // Só mostra se estiver dentro do range visível (aproximadamente)
                                            if (timeline.length > 0 && offset >= 0 && offset < timeline.length * 40) {
                                                return (
                                                    <div className="gantt-today-marker" style={{ left: `${offset}px` }}>
                                                        <div className="gantt-today-badge">Hoje</div>
                                                    </div>
                                                );
                                            }
                                            return null;
                                        })()}

                                        {planeamentoFiltrado.map(obra => (
                                            <div key={obra.id} className={`gantt-row-content ${obraLocalizada?.id === obra.id ? 'obra-localizada' : ''}`} style={{ width: `${timeline.length * 40}px` }}>

                                                {/* Barra de Atraso / Extensão */}
                                                {(() => {
                                                    // Parse safely and strip time
                                                    const parseDate = (val) => {
                                                        if (!val) return new Date();
                                                        let d;
                                                        if (val instanceof Date) {
                                                            d = new Date(val);
                                                        } else {
                                                            // Handle YYYY-MM-DD string explicitly to avoid timezone shifts
                                                            if (typeof val === 'string') {
                                                                const parts = val.split('T')[0].split('-');
                                                                if (parts.length === 3) {
                                                                    const [y, m, day] = parts.map(Number);
                                                                    d = new Date(y, m - 1, day);
                                                                } else {
                                                                    d = new Date(val);
                                                                }
                                                            } else {
                                                                d = new Date(val);
                                                            }
                                                        }
                                                        d.setHours(0, 0, 0, 0);
                                                        return d;
                                                    };

                                                    const endPlan = parseDate(obra.data_fim);
                                                    const today = new Date();
                                                    today.setHours(0, 0, 0, 0);

                                                    let extensionEnd = null;

                                                    if (obra.status === 'concluida' && obra.data_conclusao) {
                                                        const actualEnd = parseDate(obra.data_conclusao);
                                                        if (actualEnd > endPlan) extensionEnd = actualEnd;
                                                    } else if (obra.status !== 'concluida' && today > endPlan) {
                                                        extensionEnd = today;
                                                    }

                                                    if (extensionEnd) {
                                                        const delayDiffDays = Math.round((extensionEnd - endPlan) / (1000 * 60 * 60 * 24));
                                                        if (delayDiffDays > 0) {
                                                            return (
                                                                <div
                                                                    className="gantt-bar-delay"
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '9px',
                                                                        height: '20px',
                                                                        // Stripe effect: Base color + Transparent stripes
                                                                        '--obra-cor': obra.cor || '#4a90e2',
                                                                        backgroundColor: '#f7fafc', // Light background for contrast
                                                                        backgroundImage: `repeating-linear-gradient(
                                                                            45deg,
                                                                            ${obra.cor || '#4a90e2'} 0px,
                                                                            ${obra.cor || '#4a90e2'} 10px,
                                                                            rgba(255,255,255,0.8) 10px,
                                                                            rgba(255,255,255,0.8) 20px
                                                                        )`,
                                                                        opacity: 0.8, // Slightly opaque to blend nicely
                                                                        left: `${calculateOffset(obra.data_fim, timeline) + calculateWidth(obra.data_fim, obra.data_fim, timeline)}px`, // Start right after main bar
                                                                        width: `${delayDiffDays * 40}px`,
                                                                        zIndex: 9,
                                                                        borderRadius: '0 4px 4px 0',
                                                                        pointerEvents: 'none',
                                                                        border: `1px solid ${obra.cor || '#4a90e2'}`
                                                                    }}
                                                                />
                                                            );
                                                        }
                                                    }
                                                    return null;
                                                })()}

                                                {/* Barra da Obra */}
                                                {(() => {
                                                    const isDragging = dragState?.obra.id === obra.id;
                                                    const isResizing = resizeState?.obra.id === obra.id;

                                                    let left = calculateOffset(obra.data_inicio, timeline);
                                                    let width = calculateWidth(obra.data_inicio, obra.data_fim, timeline);
                                                    let transform = 'none';

                                                    if (isDragging && dragState.hasMoved) {
                                                        transform = `translateX(${dragState.currentX - dragState.startX}px)`;
                                                    } else if (isResizing) {
                                                        const deltaX = resizeState.deltaDays * 40;
                                                        if (resizeState.side === 'left') {
                                                            left += deltaX;
                                                            width -= deltaX;
                                                            // Limite mínimo de 1 dia (40px)
                                                            if (width < 40) {
                                                                left -= (40 - width);
                                                                width = 40;
                                                            }
                                                        } else {
                                                            width += deltaX;
                                                            if (width < 40) width = 40;
                                                        }
                                                    }

                                                    const atribObra = atribuicoes.filter(a => a.obra_id === obra.id);
                                                    const isDragOver = dragOverObraId === obra.id;
                                                    return (
                                                        <div
                                                            className={`gantt-bar-obra ${isDragging ? 'dragging' : ''} ${isResizing ? 'resizing' : ''} ${isDragOver ? 'drag-over' : ''}`}
                                                            style={{
                                                                backgroundColor: obra.cor || '#4a90e2',
                                                                '--obra-cor': obra.cor || '#4a90e2',
                                                                left: `${left}px`,
                                                                width: `${width}px`,
                                                                zIndex: (isDragging || isResizing) ? 100 : 10,
                                                                transform,
                                                                transition: (isDragging || isResizing) ? 'none' : 'all 0.2s ease',
                                                                cursor: isDragging ? 'grabbing' : 'grab',
                                                                boxShadow: (isDragging || isResizing) ? '0 4px 12px rgba(0,0,0,0.2)' : (isDragOver ? '0 0 0 2px #38a169 inset' : 'none')
                                                            }}
                                                            title={`Clique para editar, arraste para mover ou use as bordas para redimensionar: ${obra.posicao}`}
                                                            onMouseDown={(e) => handleMouseDown(e, obra)}
                                                            onTouchStart={(e) => handleTouchStart(e, obra)}
                                                            onDragOver={(e) => { if (draggedTrabalhador) { e.preventDefault(); e.dataTransfer.dropEffect = 'copy'; if (dragOverObraId !== obra.id) setDragOverObraId(obra.id); } }}
                                                            onDragLeave={() => { if (dragOverObraId === obra.id) setDragOverObraId(null); }}
                                                            onDrop={(e) => handleDropOnObra(e, obra)}
                                                        >
                                                            <div className="gantt-resize-handle left" onMouseDown={(e) => handleResizeStart(e, obra, 'left')} onTouchStart={(e) => handleResizeTouchStart(e, obra, 'left')} />
                                                            <span style={{ padding: '0 8px', overflow: 'hidden', textOverflow: 'ellipsis', flex: 1 }}>
                                                                {obra.posicao}{obra.descricao ? ` - ${obra.descricao}` : ''} <LiquidText>{obra.status === 'concluida' ? '✅' : ''}</LiquidText>
                                                            </span>
                                                            {atribObra.length > 0 && (() => {
                                                                const DIA_PX = 40;
                                                                const CRACHA_PX = 36;   // largura aproximada de um crachá de iniciais
                                                                const MAIS_PX = 26;     // largura do indicador "+N"
                                                                const obraStart = new Date(obra.data_inicio);
                                                                obraStart.setHours(0, 0, 0, 0);
                                                                const obraEnd = new Date(obra.data_fim);
                                                                obraEnd.setHours(0, 0, 0, 0);
                                                                const grupos = {};
                                                                atribObra.forEach(a => {
                                                                    // Intervalo efectivo da atribuição, recortado às datas da obra
                                                                    const aStart = new Date(a.data_inicio);
                                                                    aStart.setHours(0, 0, 0, 0);
                                                                    const aEnd = new Date(a.data_fim);
                                                                    aEnd.setHours(0, 0, 0, 0);
                                                                    const rangeStart = aStart < obraStart ? obraStart : aStart;
                                                                    const rangeEnd = aEnd > obraEnd ? obraEnd : aEnd;
                                                                    // Mostrar o crachá em TODAS as semanas que a atribuição cobre
                                                                    // (não apenas na semana em que começa).
                                                                    const dow0 = rangeStart.getDay();
                                                                    const diffMon0 = dow0 === 0 ? -6 : 1 - dow0;
                                                                    const monday = new Date(rangeStart);
                                                                    monday.setDate(rangeStart.getDate() + diffMon0);
                                                                    while (monday <= rangeEnd) {
                                                                        // Início visível nesta semana: máx(Segunda, início efectivo)
                                                                        const visualStart = monday < rangeStart ? rangeStart : new Date(monday);
                                                                        const offsetDias = Math.max(0, Math.round((visualStart - obraStart) / 86400000));
                                                                        // Chave local (não UTC) para não desviar a Segunda num dia
                                                                        const key = `${monday.getFullYear()}-${monday.getMonth()}-${monday.getDate()}`;
                                                                        if (!grupos[key]) grupos[key] = { offsetDias, monday: new Date(monday), items: [] };
                                                                        // Manter o offset mínimo (mais à esquerda) do grupo
                                                                        if (offsetDias < grupos[key].offsetDias) grupos[key].offsetDias = offsetDias;
                                                                        grupos[key].items.push(a);
                                                                        // Avançar para a Segunda seguinte
                                                                        monday.setDate(monday.getDate() + 7);
                                                                    }
                                                                });
                                                                return Object.entries(grupos).map(([key, g]) => {
                                                                    // Largura disponível desta semana na barra: não invadir a
                                                                    // semana seguinte (Domingo) nem ultrapassar o fim da obra.
                                                                    const grupoStart = new Date(obraStart);
                                                                    grupoStart.setDate(obraStart.getDate() + g.offsetDias);
                                                                    const weekSun = new Date(g.monday);
                                                                    weekSun.setDate(g.monday.getDate() + 6);
                                                                    const visEnd = weekSun < obraEnd ? weekSun : obraEnd;
                                                                    const diasDisp = Math.max(1, Math.round((visEnd - grupoStart) / 86400000) + 1);
                                                                    const larguraPx = diasDisp * DIA_PX - 2;
                                                                    // Quantos crachás cabem (reservando espaço para o "+N" se necessário)
                                                                    let maxChips = Math.max(1, Math.floor(larguraPx / CRACHA_PX));
                                                                    let visiveis = g.items;
                                                                    let ocultos = [];
                                                                    if (g.items.length > maxChips) {
                                                                        maxChips = Math.max(1, Math.floor((larguraPx - MAIS_PX) / CRACHA_PX));
                                                                        visiveis = g.items.slice(0, maxChips);
                                                                        ocultos = g.items.slice(maxChips);
                                                                    }
                                                                    return (
                                                                        <div
                                                                            key={key}
                                                                            className="gantt-bar-iniciais-grupo"
                                                                            style={{ left: `${g.offsetDias * DIA_PX + 2}px`, maxWidth: `${larguraPx}px` }}
                                                                        >
                                                                            {visiveis.map(a => (
                                                                                <span
                                                                                    key={a.id}
                                                                                    className="trab-inicial-chip"
                                                                                    title={`${a.trabalhador_nome}\n${new Date(a.data_inicio).toLocaleDateString('pt-PT')} - ${new Date(a.data_fim).toLocaleDateString('pt-PT')}\n(clique para remover)`}
                                                                                    onMouseDown={(e) => e.stopPropagation()}
                                                                                    onClick={async (e) => { e.stopPropagation(); if (await confirm(`Remover ${a.trabalhador_nome} desta obra?`)) handleRemoveAtribuicao(a.id); }}
                                                                                >
                                                                                    {getIniciais(a.trabalhador_nome)}
                                                                                </span>
                                                                            ))}
                                                                            {ocultos.length > 0 && (
                                                                                <span
                                                                                    className="trab-inicial-chip trab-inicial-mais"
                                                                                    title={`Mais ${ocultos.length} nesta semana:\n${ocultos.map(a => a.trabalhador_nome).join('\n')}`}
                                                                                    onMouseDown={(e) => e.stopPropagation()}
                                                                                    onClick={(e) => e.stopPropagation()}
                                                                                >
                                                                                    +{ocultos.length}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                });
                                                            })()}
                                                            <div className="gantt-resize-handle right" onMouseDown={(e) => handleResizeStart(e, obra, 'right')} onTouchStart={(e) => handleResizeTouchStart(e, obra, 'right')} />
                                                        </div>
                                                    );
                                                })()}

                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Splitter entre Gantt e painel */}
                {!loading && planeamento.length > 0 && (
                    <div
                        className="trab-panel-splitter"
                        onMouseDown={handleSplitterDown}
                        title="Arrastar para redimensionar"
                    >
                        <div className="trab-panel-splitter-handle"></div>
                    </div>
                )}

                {/* Painel de Trabalhadores (drag & drop para o Gantt) */}
                {!loading && planeamento.length > 0 && (() => {
                    const semanaFim = new Date(semanaPanel);
                    semanaFim.setDate(semanaPanel.getDate() + 6);
                    const semanaInicio = semanaPanel;
                    // Comparar por data-string (YYYY-MM-DD) em vez de objetos Date: as
                    // atribuições chegam do backend como 'YYYY-MM-DD' e new Date() interpreta-as
                    // como UTC (+1h no verão), o que excluía erradamente atribuições só ao Domingo.
                    const semanaInicioStr = formatDate(semanaInicio);
                    const semanaFimStr = formatDate(semanaFim);
                    const diaStr = (v) => String(v).slice(0, 10);
                    const atribsSemana = atribuicoes.filter(a =>
                        diaStr(a.data_inicio) <= semanaFimStr && diaStr(a.data_fim) >= semanaInicioStr
                    );
                    const trabIdsAtribuidos = new Set(atribsSemana.map(a => a.trabalhador_id));
                    // Obras visíveis no Gantt atual (já filtradas por status/cliente)
                    const obraIdsVisiveis = new Set(planeamentoFiltrado.map(o => o.id));
                    // Atribuições da semana agrupadas por trabalhador (para tooltip e flag "fora da vista")
                    const atribsPorTrab = {};
                    atribsSemana.forEach(a => {
                        (atribsPorTrab[a.trabalhador_id] = atribsPorTrab[a.trabalhador_id] || []).push(a);
                    });
                    const atribuidos = trabalhadoresAptos.filter(t => trabIdsAtribuidos.has(t.id));
                    const livres = trabalhadoresAptos.filter(t => !trabIdsAtribuidos.has(t.id));
                    const fmt = (d) => `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`;
                    const shiftSemana = (dias) => {
                        const novo = new Date(semanaPanel);
                        novo.setDate(novo.getDate() + dias);
                        setSemanaPanel(novo);
                    };
                    const semanaHoje = () => {
                        const hoje = new Date();
                        hoje.setHours(0, 0, 0, 0);
                        const dow = hoje.getDay();
                        const diff = dow === 0 ? -6 : 1 - dow;
                        const seg = new Date(hoje);
                        seg.setDate(hoje.getDate() + diff);
                        setSemanaPanel(seg);
                    };
                    const renderChip = (t, atribuido) => {
                        const minhas = atribsPorTrab[t.id] || [];
                        // Está alocado a alguma obra que NÃO aparece no Gantt atual (concluída, filtrada, etc.)
                        const foraDaVista = atribuido && minhas.some(a => !obraIdsVisiveis.has(a.obra_id));
                        const obraLabel = (a) => {
                            const pos = a.obra_posicao || `#${a.obra_id}`;
                            const desc = a.obra_descricao ? ` - ${a.obra_descricao}` : '';
                            const est = a.obra_status && a.obra_status !== 'planeada' && a.obra_status !== 'em_curso'
                                ? ` [${a.obra_status}]` : '';
                            const oculta = !obraIdsVisiveis.has(a.obra_id) ? ' ⚠ fora do filtro atual' : '';
                            const di = new Date(a.data_inicio).toLocaleDateString('pt-PT');
                            const df = new Date(a.data_fim).toLocaleDateString('pt-PT');
                            return `${pos}${desc}${est} (${di}–${df})${oculta}`;
                        };
                        const titulo = atribuido
                            ? `${t.nome} — alocado esta semana em:\n${minhas.map(obraLabel).join('\n')}`
                            : `Arrastar ${t.nome} para uma obra`;
                        return (
                            <div
                                key={t.id}
                                className={`trab-chip ${atribuido ? 'atribuido' : 'livre'} ${foraDaVista ? 'fora-vista' : ''} ${draggedTrabalhador?.id === t.id ? 'dragging' : ''}`}
                                draggable
                                onDragStart={(e) => handleDragStartTrabalhador(e, t)}
                                onDragEnd={handleDragEndTrabalhador}
                                title={titulo}
                            >
                                <span className="trab-chip-iniciais">{getIniciais(t.nome)}</span>
                                <span className="trab-chip-nome">{t.nome}</span>
                                {foraDaVista && <span className="trab-chip-flag" title="Alocado a uma obra que não está visível no filtro atual"><LiquidText>⚠</LiquidText></span>}
                            </div>
                        );
                    };
                    return (
                        <div className="trab-panel" style={panelHeight != null ? { height: `${panelHeight}px`, display: 'flex', flexDirection: 'column' } : undefined}>
                            <div className="trab-panel-header">
                                <strong><PlanningIcon name="users" fallback="👷" /> Trabalhadores Aptos</strong>
                                <div className="trab-week-selector">
                                    <button type="button" onClick={() => shiftSemana(-7)} title="Semana anterior"><LiquidText>◀</LiquidText></button>
                                    <span className="trab-week-label">Semana {fmt(semanaInicio)} – {fmt(semanaFim)}</span>
                                    <button type="button" onClick={() => shiftSemana(7)} title="Semana seguinte"><PlanningIcon name="next" fallback="▶" /></button>
                                    <button type="button" className="trab-week-today" onClick={semanaHoje} title="Voltar à semana actual">Hoje</button>
                                </div>
                                <span className="trab-panel-hint">Arraste para uma obra. Clique numa inicial para remover.</span>
                            </div>
                            {trabalhadoresAptos.length === 0 ? (
                                <div style={{ color: '#94a3b8', fontSize: 12, padding: '4px 0' }}>Sem trabalhadores aptos. Marque "Apto para Obras" nas fichas.</div>
                            ) : (
                                <div className="trab-panel-grupos">
                                    <div className="trab-panel-grupo">
                                        <span className="trab-grupo-label livre"><LiquidText>🟢 Livres (</LiquidText>{livres.length})</span>
                                        <div className="trab-panel-list">
                                            {livres.length === 0 ? <em className="trab-empty">— nenhum —</em> : livres.map(t => renderChip(t, false))}
                                        </div>
                                    </div>
                                    <div className="trab-panel-grupo">
                                        <span className="trab-grupo-label atribuido"><LiquidText>🔵 Atribuídos (</LiquidText>{atribuidos.length})</span>
                                        <div className="trab-panel-list">
                                            {atribuidos.length === 0 ? <em className="trab-empty">— nenhum —</em> : atribuidos.map(t => renderChip(t, true))}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                })()}

                {/* Splitter inferior para encolher o painel */}
                {!loading && planeamento.length > 0 && (
                    <div
                        className="trab-panel-splitter trab-panel-splitter-bottom"
                        onMouseDown={handlePanelSplitterDown}
                        title="Arrastar para redimensionar o painel"
                    >
                        <div className="trab-panel-splitter-handle"></div>
                    </div>
                )}

                {/* Modal de Edição */}
                {editingObra && (
                    <PlanningDialog data-planning-dialog="true" label="Planeamento" onClose={() => setEditingObra(null)}>
                        <div className="modal-ef" style={{ maxWidth: 960, width: '92vw', maxHeight: '88vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
                            <div className="modal-ef-header">
                                <div>
                                    <span className="modal-ef-num">{editingObra.isNew ? 'Nova Obra' : `${editingObra.posicao}${editingObra.descricao ? ` - ${editingObra.descricao}` : ''}`}</span>
                                    {!editingObra.isNew && <span className={`ef-estado ef-estado-${editingObra.status}`} style={{ marginLeft: 10 }}>{editingObra.status}</span>}
                                </div>
                                <button className="modal-close" aria-label="Fechar" onClick={() => setEditingObra(null)}><PlanningIcon name="close" fallback="✕" /></button>
                            </div>
                            <div className="modal-form-body" style={{ overflowY: 'auto', flex: 1, padding: '16px 28px 0' }}>
                                <form onSubmit={handleSaveObra}>
                                    <div className="modal-form-grid">
                                        <div className="modal-field">
                                            <label>POSIÇÃO / REFERÊNCIA</label>
                                            <input value={editingObra.posicao} onChange={e => setEditingObra({ ...editingObra, posicao: e.target.value })} />
                                        </div>
                                        <div className="modal-field">
                                            <label>CLIENTE</label>
                                            <select
                                                value={editingObra.cliente_id || ''}
                                                onChange={e => {
                                                    const c = clientes.find(cl => String(cl.id) === e.target.value);
                                                    setEditingObra({ ...editingObra, cliente_id: e.target.value, cliente: c ? c.nome : '' });
                                                }}
                                            >
                                                <option value="">
                                                    {editingObra.cliente && !editingObra.cliente_id ? editingObra.cliente : '-- Selecionar cliente --'}
                                                </option>
                                                {clientes.map(c => (
                                                    <option key={c.id} value={c.id}>{c.nome}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="modal-field full">
                                            <label>NOME DA OBRA / LOCAL</label>
                                            <input value={editingObra.descricao || ''} onChange={e => setEditingObra({ ...editingObra, descricao: e.target.value })} />
                                        </div>
                                        <div className="modal-field">
                                            <label>DATA INÍCIO</label>
                                            <input type="date" value={editingObra.data_inicio?.split('T')[0]} onChange={e => setEditingObra({ ...editingObra, data_inicio: e.target.value })} />
                                        </div>
                                        <div className="modal-field">
                                            <label>DATA FIM</label>
                                            <input type="date" value={editingObra.data_fim?.split('T')[0]} onChange={e => setEditingObra({ ...editingObra, data_fim: e.target.value })} />
                                        </div>
                                        <div className="modal-field">
                                            <label>ESTADO</label>
                                            <select value={editingObra.status} onChange={e => setEditingObra({ ...editingObra, status: e.target.value })}>
                                                <option value="planeada">Planeada</option>
                                                <option value="em_curso">Em Curso</option>
                                                <option value="concluida">Concluída</option>
                                                <option value="suspensa">Suspensa</option>
                                            </select>
                                        </div>
                                        <div className="modal-field">
                                            <label>TIPO</label>
                                            <select value={editingObra.tipo_obra || 'obra'} onChange={e => { const tipo = e.target.value; setEditingObra(prev => ({ ...prev, tipo_obra: tipo, ...(prev.isNew ? { cor: tipo === 'pendencia' ? '#e53e3e' : tipo === 'manutencao' ? '#805ad5' : '#3182ce' } : {}) })); }}>
                                                <option value="obra">Obra</option>
                                                <option value="manutencao">Manutenção</option>
                                                <option value="pendencia">Pendência</option>
                                            </select>
                                        </div>
                                        <div className="modal-field">
                                            <label>COR</label>
                                            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', paddingTop: 4 }}>
                                                {PREDEFINED_COLORS.map(c => (
                                                    <button key={c} type="button" style={{ width: 28, height: 28, borderRadius: 6, backgroundColor: c, border: editingObra.cor === c ? '2px solid #1e293b' : '2px solid transparent', cursor: 'pointer', boxShadow: editingObra.cor === c ? '0 0 0 2px white inset' : 'none' }} onClick={() => setEditingObra({ ...editingObra, cor: c })} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Observações — no topo, logo abaixo da cor: nas manutenções/pendências
                                        é aqui que se escreve o descritivo do que é para fazer */}
                                    <div className="modal-field full" style={{ marginBottom: 8 }}>
                                        <label>OBSERVAÇÕES / DESCRITIVO DO TRABALHO</label>
                                        <textarea rows={3} value={editingObra.observacoes || ''} onChange={e => setEditingObra({ ...editingObra, observacoes: e.target.value })} placeholder="Descritivo do que é para fazer (manutenções/pendências) ou notas sobre o decurso dos trabalhos..." />
                                    </div>

                                    {/* Anexos — ex.: relatório da fiscalização; ficam visíveis ao técnico no mobile */}
                                    <div className="modal-field full" style={{ marginBottom: 12 }}>
                                        <label>ANEXOS (ex.: relatório da fiscalização)</label>
                                        {anexos.length > 0 && (
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 8 }}>
                                                {anexos.map(a => (
                                                    <div data-liquid-actions="true" key={a.id} style={{ display: 'flex', alignItems: 'center', gap: 8, background: '#f7fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: '7px 10px' }}>
                                                        <span style={{ flex: 1, fontSize: 13 }}><LiquidText>📎 </LiquidText>{a.nome_original}
                                                            <span style={{ color: '#94a3b8', fontSize: 11 }}> · {Math.max(1, Math.round((a.tamanho || 0) / 1024))} KB</span>
                                                        </span>
                                                        <button type="button" onClick={() => abrirAnexo(a)} style={{ border: '1px solid #cbd5e0', background: '#fff', borderRadius: 6, padding: '3px 10px', fontSize: 12, cursor: 'pointer' }}>Abrir</button>
                                                        <button type="button" onClick={() => removerAnexo(a)} style={{ border: 'none', background: 'none', color: '#e53e3e', fontWeight: 700, cursor: 'pointer' }} aria-label="Apagar" title="Apagar"><DeleteIcon /></button>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                        {anexosNovos.length > 0 && (
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 8 }}>
                                                {anexosNovos.map((f, i) => (
                                                    <span key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#fef9c3', border: '1px solid #fde68a', borderRadius: 12, padding: '4px 10px', fontSize: 12 }}><LiquidText>
                                                        📎 </LiquidText>{f.name} (ao guardar)
                                                        <button type="button" onClick={() => setAnexosNovos(prev => prev.filter((_, x) => x !== i))} style={{ border: 'none', background: 'none', color: '#e53e3e', fontWeight: 700, cursor: 'pointer', padding: 0 }}><PlanningIcon name="close" fallback="×" /></button>
                                                    </span>
                                                ))}
                                            </div>
                                        )}
                                        <input type="file" multiple onChange={handleAnexoUpload} disabled={anexoBusy} style={{ fontSize: 13 }} />
                                        {anexoBusy && <span style={{ fontSize: 12, color: '#718096' }}> a carregar…</span>}
                                    </div>

                                    {/* Trabalhos Previstos */}
                                    <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: 14, marginTop: 8, marginBottom: 14 }}>
                                        <label style={{ fontSize: 10, fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '0.4px' }}>TRABALHOS PREVISTOS</label>
                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginTop: 8 }}>
                                            {[...new Set(availableWorkItems.map(i => i.categoria))].map(cat => (
                                                <div key={cat}>
                                                    {(() => {
                                                        const daCategoria = availableWorkItems.filter(i => i.categoria === cat);
                                                        const selecionados = (editingObra.detalhes_trabalho || []).filter(d => daCategoria.some(i => i.id === d.id));
                                                        const disponiveis = daCategoria.filter(i => !selecionados.some(d => d.id === i.id));
                                                        return (
                                                            <>
                                                                <div style={{ fontSize: 10, fontWeight: 700, color: '#888', textTransform: 'uppercase', borderBottom: '1px solid #edf2f7', paddingBottom: 4, marginBottom: 6 }}>
                                                                    {cat}{selecionados.length > 0 ? ` (${selecionados.length})` : ''}
                                                                </div>
                                                                {selecionados.map(d => (
                                                                    <div key={d.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 6, padding: '4px 8px', borderRadius: 6, background: '#f0f4ff', marginBottom: 4 }}>
                                                                        <span style={{ display: 'flex', alignItems: 'center', gap: 6, flex: 1, fontSize: 13, color: '#3730a3' }}>
                                                                            <span><LiquidText>{d.icone}</LiquidText></span>
                                                                            <span>{d.nome}</span>
                                                                        </span>
                                                                        <input type="number" min="1" value={d.quantidade || 1} title="Quantidade" onChange={(e) => {
                                                                            const newDetalhes = (editingObra.detalhes_trabalho || []).map(x => x.id === d.id ? { ...x, quantidade: parseInt(e.target.value) || 1 } : x);
                                                                            setEditingObra({ ...editingObra, detalhes_trabalho: newDetalhes });
                                                                        }} style={{ width: 42, fontSize: 13, padding: '2px 4px', border: '1px solid #5b4fcf', borderRadius: 6, textAlign: 'center', fontWeight: 600, color: '#3730a3' }} />
                                                                        <button type="button" title="Remover" onClick={() => {
                                                                            const newDetalhes = (editingObra.detalhes_trabalho || []).filter(x => x.id !== d.id);
                                                                            setEditingObra({ ...editingObra, detalhes_trabalho: newDetalhes, tipo_trabalho: newDetalhes.map(x => x.nome) });
                                                                        }} style={{ border: 'none', background: 'none', color: '#e53e3e', fontWeight: 700, cursor: 'pointer', padding: '0 2px' }}><DeleteIcon /></button>
                                                                    </div>
                                                                ))}
                                                                {disponiveis.length > 0 && (
                                                                    <select value="" onChange={(e) => {
                                                                        const item = daCategoria.find(i => String(i.id) === e.target.value);
                                                                        if (!item) return;
                                                                        const newDetalhes = [...(editingObra.detalhes_trabalho || []), { ...item, quantidade: 1 }];
                                                                        setEditingObra({ ...editingObra, detalhes_trabalho: newDetalhes, tipo_trabalho: newDetalhes.map(x => x.nome) });
                                                                    }} style={{ width: '100%', padding: '6px 8px', fontSize: 13, border: '1px dashed #a0aec0', borderRadius: 6, color: '#4a5568', background: '#fafbfc', cursor: 'pointer' }}>
                                                                        <option value="">➕ Adicionar trabalho…</option>
                                                                        {disponiveis.map(i => (
                                                                            <option key={i.id} value={i.id}>{i.icone ? `${i.icone} ` : ''}{i.nome}</option>
                                                                        ))}
                                                                    </select>
                                                                )}
                                                            </>
                                                        );
                                                    })()}
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Detalhe de Obra */}
                                    <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: 14, marginBottom: 14 }}>
                                        <label style={{ fontSize: 10, fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '0.4px' }}>DETALHE DE OBRA</label>
                                        <div className="modal-form-grid" style={{ marginTop: 8 }}>
                                            <div className="modal-field">
                                                <label>RESP. OBRA (CLIENTE)</label>
                                                <select value={editingObra.responsavel_cliente_id || ''} onChange={e => { const userId = e.target.value; const user = users.find(u => u.id === parseInt(userId)); setEditingObra({ ...editingObra, responsavel_cliente_id: userId, email_responsavel_cliente: user ? user.email : '', telefone_responsavel_cliente: user ? (user.telefone || '') : '' }); }}>
                                                    <option value="">Selecione...</option>
                                                    {users.filter(u => u.tipo_utilizador === 'externo').map(u => <option key={u.id} value={u.id}>{u.nome_completo}</option>)}
                                                </select>
                                            </div>
                                            <div className="modal-field">
                                                <label>RESP. OBRA (INTERNO)</label>
                                                <select value={editingObra.responsavel_obra_id || ''} onChange={e => { const userId = e.target.value; const user = users.find(u => u.id === parseInt(userId)); setEditingObra({ ...editingObra, responsavel_obra_id: userId, email_responsavel: user ? user.email : '', telefone_responsavel: user ? (user.telefone || '') : '' }); }}>
                                                    <option value="">Selecione...</option>
                                                    {users.map(u => <option key={u.id} value={u.id}>{u.nome_completo}</option>)}
                                                </select>
                                            </div>
                                            <div className="modal-field">
                                                <label>SEGURANÇA OBRA</label>
                                                <select value={editingObra.seguranca_obra_id || ''} onChange={e => { const userId = e.target.value; const user = users.find(u => u.id === parseInt(userId)); setEditingObra({ ...editingObra, seguranca_obra_id: userId, email_seguranca: user ? user.email : '', telefone_seguranca: user ? (user.telefone || '') : '' }); }}>
                                                    <option value="">Selecione...</option>
                                                    {users.map(u => <option key={u.id} value={u.id}>{u.nome_completo}</option>)}
                                                </select>
                                            </div>
                                            <div className="modal-field">
                                                <label>FISCALIZAÇÃO</label>
                                                <select value={editingObra.fiscalizacao_id || ''} onChange={e => { const userId = e.target.value; const user = users.find(u => u.id === parseInt(userId)); setEditingObra({ ...editingObra, fiscalizacao_id: userId, nome_fiscalizacao: user ? user.nome_completo : '', email_fiscalizacao: user ? user.email : '', telefone_fiscalizacao: user ? (user.telefone || '') : '' }); }}>
                                                    <option value="">Selecione...</option>
                                                    {users.map(u => <option key={u.id} value={u.id}>{u.nome_completo}</option>)}
                                                </select>
                                            </div>
                                            <div className="modal-field">
                                                <label>DOC. VALIDADA?</label>
                                                <select value={editingObra.documentacao_validada || ''} onChange={e => setEditingObra({ ...editingObra, documentacao_validada: e.target.value })}>
                                                    <option value="">Selecione...</option>
                                                    <option value="s">Sim</option>
                                                    <option value="n">Não</option>
                                                </select>
                                            </div>
                                            <div className="modal-field">
                                                <label>NECESSIDADE DE AT?</label>
                                                <select value={editingObra.necessidade_at || ''} onChange={e => setEditingObra({ ...editingObra, necessidade_at: e.target.value })}>
                                                    <option value="">Selecione...</option>
                                                    <option value="s">Sim</option>
                                                    <option value="n">Não</option>
                                                </select>
                                            </div>
                                            <div className="modal-field">
                                                <label>TIPO DE AT</label>
                                                <input value={editingObra.tipo_at || ''} onChange={e => setEditingObra({ ...editingObra, tipo_at: e.target.value })} placeholder="Ex: 1.ª AT" />
                                            </div>
                                            <div className="modal-field">
                                                <label>DATA TRABALHO AT</label>
                                                <input type="date" value={editingObra.data_at ? editingObra.data_at.split('T')[0] : ''} onChange={e => setEditingObra({ ...editingObra, data_at: e.target.value })} />
                                            </div>
                                            <div className="modal-field">
                                                <label>HORA EMISSÃO AT</label>
                                                <input type="time" value={editingObra.hora_at || ''} onChange={e => setEditingObra({ ...editingObra, hora_at: e.target.value })} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="modal-form-actions" style={{ justifyContent: 'space-between' }}>
                                        {editingObra.isNew
                                            ? <span />
                                            : <button type="button" className="btn-modal-cancel" onClick={handleDeleteObra} style={{ color: '#e53e3e', borderColor: '#fca5a5' }}><DeleteIcon /> Eliminar</button>}
                                        <div data-liquid-actions="true" style={{ display: 'flex', gap: 8 }}>
                                            <button type="button" className="btn-modal-cancel" onClick={() => setEditingObra(null)}>Cancelar</button>
                                            <button type="submit" className="btn-modal-save">{editingObra.isNew ? 'Criar Obra' : 'Guardar'}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </PlanningDialog>
                )}

                {/* Painel de Alertas Pendentes */}
                {justifyModal && (
                    <PlanningDialog data-planning-dialog="true" label="Planeamento" onClose={() => setJustifyModal(null)}>
                        <div className={liquid ? "planeamento-modal-content modal-ef" : "planeamento-modal-content"} style={{ maxWidth: 480 }}>
                            <header className={liquid ? "modal-header modal-ef-header" : "modal-header"}>
                                <h2><PlanningIcon name="edit" fallback="✏️" /> Personalizar mensagem</h2>
                                <button className={liquid ? "btn-close modal-close" : "btn-close"} aria-label="Fechar" onClick={() => setJustifyModal(null)}><PlanningIcon name="close" fallback="×" /></button>
                            </header>
                            <div className={liquid ? "modal-form-body planeamento-dialog-body" : undefined} style={{ padding: '16px 20px' }}>
                                <p style={{ fontSize: 13, color: '#555', marginBottom: 12 }}>
                                    Justificação para a alteração da obra <strong>{justifyModal.posicao} – {justifyModal.cliente}</strong>.<br />
                                    <span style={{ color: '#888' }}>Opcional. Será incluída no corpo do email.</span>
                                </p>
                                <textarea
                                    value={justifyText}
                                    onChange={e => setJustifyText(e.target.value)}
                                    placeholder="Ex: Reagendamento devido a condições meteorológicas adversas."
                                    rows={4}
                                    style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #d1d5db', fontSize: 13, resize: 'vertical', boxSizing: 'border-box' }}
                                    autoFocus
                                />
                                <div data-liquid-actions="true" style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
                                    <button className="btn-dismiss" style={{ padding: '6px 14px' }} onClick={() => setJustifyModal(null)}>Cancelar</button>
                                    <button className="btn-send" style={{ padding: '6px 16px' }} onClick={handleConfirmWithJustify}>Enviar email</button>
                                </div>
                            </div>
                        </div>
                    </PlanningDialog>
                )}
                {pendingAlerts.length > 0 && (
                    <div className="pending-alerts-floating-panel">
                        <header>
                            <span><PlanningIcon name="warning" fallback="🚩" /> Alterações ao Planeamento ({pendingAlerts.length})</span>
                            {pendingAlerts.length > 1 && (
                                <div className="alerts-bulk-actions">
                                    <button className="btn-send" onClick={handleSendAllAlerts} title="Enviar todos os avisos">Enviar todos</button>
                                    <button className="btn-dismiss" onClick={handleDismissAllAlerts} title="Dispensar todos os avisos">Dispensar todos</button>
                                </div>
                            )}
                        </header>
                        <div className="alerts-list">
                            {pendingAlerts.map(alert => (
                                <div key={alert.id} className="alert-item">
                                    <div className="alert-info">
                                        <strong>{alert.posicao}</strong>
                                        <span>{new Date(alert.data_inicio_nova).toLocaleDateString()} - {new Date(alert.data_fim_nova).toLocaleDateString()}</span>
                                    </div>
                                    <div className="alert-actions">
                                        <button className="btn-customize" title="Personalizar mensagem" onClick={() => { setJustifyModal(alert); setJustifyText(''); }}><PlanningIcon name="edit" fallback="✏️" /></button>
                                        <button className="btn-send" onClick={() => handleConfirmAlert(alert.id)}>Enviar</button>
                                        <button className="btn-dismiss" onClick={() => handleDismissAlert(alert.id)}><PlanningIcon name="close" fallback="×" /></button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

// Funções auxiliares para cálculo de posição
const calculateOffset = (startDate, timeline) => {
    if (!startDate || timeline.length === 0) return 0;

    const parseSafely = (val) => {
        if (!val) return new Date();
        if (val instanceof Date) return val;
        try {
            const [y, m, d] = String(val).split('T')[0].split('-').map(Number);
            return new Date(y, m - 1, d);
        } catch (e) {
            return new Date();
        }
    };

    const start = parseSafely(startDate);
    const timelineStart = timeline[0];

    // Reset times to midnight for clean day calculation
    const d1 = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    const d2 = new Date(timelineStart.getFullYear(), timelineStart.getMonth(), timelineStart.getDate());

    const diffTime = d1 - d2;
    const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));
    return Math.max(0, diffDays * 40); // 40px por dia
};

const calculateWidth = (startDate, endDate, timeline) => {
    if (!startDate || !endDate) return 100;

    const parseSafely = (val) => {
        if (!val) return new Date();
        if (val instanceof Date) return val;
        try {
            const [y, m, d] = String(val).split('T')[0].split('-').map(Number);
            return new Date(y, m - 1, d);
        } catch (e) {
            return new Date();
        }
    };

    const start = parseSafely(startDate);
    const end = parseSafely(endDate);

    const d1 = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    const d2 = new Date(end.getFullYear(), end.getMonth(), end.getDate());

    const diffTime = d2 - d1;
    const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24)) + 1;
    return Math.max(40, diffDays * 40);
};

export default function Planeamento() {
    return <PlanningFeedbackProvider><PlaneamentoContent /></PlanningFeedbackProvider>;
}
